import _ from "lodash";
import React from "react";
import client from "lib/apolloClient/client";

import { AicnMobileSettings, AicnPOI, AicnNews } from "SvgComponents";
import {
  Announcements3D,
  Integrations3D,
  School3D,
  AttendanceManager3D,
  Settings3D,
  Files3D,
  Bin3D,
  Transcripts3D,
  ProgressSummary3D,
  StaffPermissions3D,
  Goals3D,
  FamilyCommunication3D,
  Document3D,
  HeadHeart3D,
  SetupOutlined,
  OpenBookTextOutlined,
  ProgressReportOutlined,
  ClipboardPencilLinesOutlined,
  AttendanceOutlined,
  DeleteOutlined,
  NotificationSettingsOutlined,
  PolicyTickOutlined,
  SpiralBookLinesOutlined,
  SettingsOutlined,
  UserReflectionOutlined,
} from "@toddle-edu/ds-icons";
import {
  OPERATIONAL_DAYS_AND_TIME_ZONE_PERM,
  ENABLE_PYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
  ENABLE_MYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
  ENABLE_DP_DYNAMIC_PLANNER_ELEMENT_LABEL,
  ENABLE_SCHOOL_ANALYTICS,
  ENABLE_TEMPLATE_FIELDS,
  ENABLE_CUSTOM_DATA_SETS,
  ENABLE_ACTION_SET_EDITING,
  ENABLE_BEHAVIOUR_MODULE_PERM,
  ENABLE_BEHAVIOUR_MODULE_IN_ADMIN_PORTAL,
  ENABLE_ROLES_AND_PERMISSIONS_PERMISSION,
  SNPv2_ACCESS_PERMISSION,
  ATTENDANCE_DASHBOARD_ACCESS_PERMISSION,
  VIEW_AND_MANAGE_NOTIFICATIONS,
  SCHOOL_OVERVIEW_ACCESS_PERMISSION,
  SCHOOL_ROSTER_ACCESS_PERMISSION,
  SCHOOL_ROSTER_ACCESS_PERMISSION_FOR_ACCOUNT,
  ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION,
  VIEW_SCHOOL_POLICIES_AND_RESOURCES_MODULE_PERMISSION,
  BIN_ACCESS_PERM,
  VISITORS_VIEW_AND_MANAGE_PERMISSION,
  CAS_SUPERVISORS_VIEW_AND_MANAGE_PERMISSION,
  IBIS_REGISTRATION_ACCESS_PERMISSION,
  ACADEMIC_SETUP_VIEW_PERM,
  PROGRESS_REPORTS_ADMIN_LEVEL_VIEW_PERMISSION,
  TRANSCRIPT_ADMIN_LEVEL_VIEW_PERMISSION,
  INTEGRATIONS_VIEW_AND_MANAGE_PERM,
  INTEGRATIONS_PROGRAMME_LEVEL_VIEW_AND_MANAGE_PERM,
  MODULE_SETTINGS_ACCESS_PERMISSION,
  ENABLE_IBECOURSEWORK,
  SCHOOL_WIDE_SETTINGS_ACCESS_PERMISSION,
  ADMIN_GRADEBOOK_ACCESS_PERMISSION,
  CAN_VIEW_TIMETABLE_CONFIGURATIONS_PERMISSION,
  ATTENDANCE_SETTINGS_ACCESS_PERMISSION,
  ATTENDANCE_SETTINGS_V2_ACCESS_PERMISSION,
  ACADEMY_ANALYTICS_ACCESS_PERMISSION,
  ENABLE_ROUTINE_TEMPLATES,
  CAN_VIEW_LOGIN_CONFIGURATION,
  BEHAVIOUR_SETUP_ACCESS_PERMISSION,
  ENABLE_BEHAVIOUR_SETUP_CARD,
  ACTIVITY_LOG_PERMISSION,
  ENABLE_MODULE_SETTINGS_IN_PROGRAMME_WIDE_CONFIGURATIONS,
  GRADING_SETUP_V2_PERM,
  CAN_VIEW_SCHOOL_TIMETABLE_CONFIGURATIONS_V2_PERMISSION,
  ENABLE_GRADE_WISE_REFLECTION_QUESTIONS,
  LEARNING_GOALS_GRADING_PERM,
  GRADING_VISIBILITY_SETTINGS_PERM,
  GRADING_VISIBILITY_SETTINGS_V2_PERM,
  CAN_VIEW_STUDENT_ALERT_SETTINGS,
  IS_MFA_ENABLED,
} from "Constants/permissionConstants";
import {
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_UBD,
  CURRICULUM_TYPE_DP,
  ELEMENT_TYPE_PYP_LEARNING_STANDARD,
  ELEMENT_TYPE_PYP_ATL,
  ELEMENT_TYPE_PYP_LEARNER_PROFILE,
  CURRICULUM_VARIANT_TODDLE_PLAY,
  SCHOOL_INFORMATION,
} from "Constants/stringConstants";
import {
  getAdminMenuUid,
  removeIBPrefixFromCurriculumType,
  getStaffPermissionSideBarNodeOnLeaveInterceptor,
  getSchoolConfigurationAccessModule,
  getConfigurationAccess,
} from "Administrator/modules/Utils";
import ACLStore from "lib/aclStore";
import { getIsAdminByRole, MODULES } from "lib/staffPermissionUtils";
import { getCurriculumProgramLabel } from "Platform/modules/PlatformUtils";
import { ATTENDANCE_CONSTANTS } from "AttendanceDashboard/constants/stringConstants";
import { teacherPortfolioLeaveInterceptor } from "./routes/Settings/routes/PortfolioManager/routes/TeacherPortfolio/modules/TeacherPortfolioModule";
import { reviewerSetupLeaveInterceptor } from "./routes/Settings/routes/PortfolioManager/routes/ReviewerSetup/modules/ReviewerSetupModule";
import { parseConfigurationValue } from "Utils";
import { isEducatorCenterRevampParentPermEnabled } from "AdminEducatorCenterV2/modules/AdminEducatorCenterV2Utils.js";
import {
  MESSAGING_MODULE_OPENED_FROM,
  recordMessagingModuleOpened,
} from "MessagingV2/modules/Utils";
import InvalidConfigWarning from "AnnouncementsManager/routes/ReviewerSetup/components/InvalidConfigWarning";
import { initiateSentimentAnalysisMutation } from "MessagingV2/modules/MessagingMutation";

import WarningTooltip from "Administrator/routes/Settings/routes/PortfolioManager/routes/ReviewerSetup/components/commonComponents/WarningTooltip/";
import { getIsBehaviourSetupCardEnabled } from "BehaviourManagement/modules/Utils";
import { getIsLearningCoursesEnabled } from "LearningCourses/modules/Utils";
import {
  checkIsSentralFeatureEnabledInCurriculums,
  SENTRAL_PERMISSION_CONFIGURATIONS,
} from "Login/components/SentralPortalModal/SentralPortalUtils";
import { authorizeUserWithEsfSentral } from "Login/modules/LoginModule";
import IconAvatar from "Administrator/components/IconAvatar";

export const AdminMenu = {
  rootNodes: [
    {
      id: "SCHOOL_CONFIGURATIONS",
      label: "common:school_configurations",
      subLabel: "common:school_configurations_message",
      levelId: "ROOT",
      children: [
        "CIRCULARS",
        "INTEGRATION_SETTINGS",
        "MESSAGING_V2",
        "SCHOOL_SETUP",
        "TRANSCRIPTS",
        "STAFF_PERMISSIONS",
        "BEHAVIOUR_MANAGEMENT",
        "BEHAVIOUR_CONFIGURATION",
        // "TRASH",
        "SCHOOL_ANALYTICS",
        "ACTIVITY_LOGS",
        "ACADEMY_ANALYTICS",
        "SCHOOL_SETTINGS_MODULE",
        // the following is only visible on staging for one org only based on permission
        "GENERATE_SENTIMENT_ANALYSIS",
        "BULK_UPLOAD_ACTIONS",
        "ATTENDANCE_SETTINGS_V2",
        // "ATTENDANCE_AND_TIMETABLE_SETTINGS",
        // "TIMETABLE_SETTINGS",
        "ROLES_AND_PERMISSIONS",
      ],
      uptoLevel: 1, // Specify till which level to go to display children as cards
    },
    {
      id: "CURRICULUM_CONFIGURATIONS",
      label: "common:program_configurations",
      subLabel: "common:program_configurations_message",
      levelId: "ROOT",
      uptoLevel: 2,
      isDynamicNode: true,
    },
  ],
  nodes: [
    {
      id: "BULK_UPLOAD_ACTIONS",
      label: "common:bulk_upload_actions",
      children: [],
      levelId: "L1",
      route: "bulk-upload-actions",
      icon: <Files3D />,
      iconBgColor: "var(--teal-900)",
      perm: [
        "Common:BulkUploadAttendance",
        "AdminPortal:ProfilePictureBulkupload",
      ],
    },
    {
      id: "ATTENDANCE_SETTINGS_V2",
      label: "common:attendance_settings_sentence_case",
      children: [],
      curriculumPrograms: ["IB_PYP", "IB_MYP", "UBD", "IB_DP"],
      route: "attendance-settings",
      levelId: "L1",
      icon: <AttendanceManager3D />,
      iconBgColor: "var(--yellow-900)",
      showBreadCrumb: false,
      perm: "FeatureFlag:AttendanceSettingsV2",
      permission: ATTENDANCE_SETTINGS_V2_ACCESS_PERMISSION,
      rolesAndPermissionKey: "ATTENDANCE",
    },
    // {
    //   id: "ATTENDANCE_AND_TIMETABLE_SETTINGS",
    //   label: "attendance:timetable_settings",
    //   children: [],
    //   curriculumPrograms: ["IB_PYP", "IB_MYP", "UBD", "IB_DP"],
    //   route: "attendance-and-timetable-settings",
    //   levelId: "L1",
    //   icon: <AttendanceManager3D />,
    //   iconBgColor: "var(--yellow-900)",
    //   showBreadCrumb: false,
    //   perm: "FeatureFlag:Toddle2.0Timetable",
    // },
    // {
    //   id: "TIMETABLE_SETTINGS",
    //   label: "attendance:timetable_settings",
    //   children: [],
    //   curriculumPrograms: ["IB_PYP", "IB_MYP", "UBD", "IB_DP"],
    //   route: "timetable-settings",
    //   levelId: "L1",
    //   icon: <Calendar3D />,
    //   iconBgColor: "var(--yellow-900)",
    //   showBreadCrumb: false,
    //   perm: ["FeatureFlag:TimetableV3"],
    // },
    {
      id: "IB_DP",
      label: "common:dp",
      children: [
        "DP_ACADEMIC_SETUP",
        "DP_SNP",
        "DP_CORE_SETUP",
        "DP_IBIS_EXAM_REGISTRATION",
        "DP_IBIS_REGISTRATION",
        "DP_IB_E_COURSEWORK",
        "DP_EDUCATOR_CENTER",
        "DP_EDUCATOR_CENTER_V2",
        "DP_PROGRESS_REPORTS",
        "DP_ADMIN_GRADEBOOK",
        "DP_ATTENDANCE_DASHBOARD",

        "DP_SETTINGS",
        "DP_TIMETABLE",
        "DP_ATTENDANCE_AND_TIMETABLE_SETTINGS",
        "DP_WORKSHEET_QUESTION_LIBRARY",
        "DP_TRASH",
        "DP_TIMETABLE_MANAGER",
        "DP_NOTIFICATIONS_MANAGER",
        "DP_ESF_SENTRAL_WELLBEING",
        "DP_ESF_SENTRAL_TIMETABLE",
        "DP_ESF_SENTRAL_ATTENDANCE",
        "DP_ESF_SENTRAL_POLICIES",
      ],
      curriculumPrograms: ["IB_DP"],
      levelId: "L0",
      isDynamicNode: true,
      skipRolesAndPermissionsCheck: true,
      isProgramRootNode: true,
    },
    {
      id: "IB_PYP",
      label: "common:pyp",
      children: [
        "PYP_ACADEMIC_SETUP",
        "PYP_SNP",
        "PYP_EDUCATOR_CENTER",
        "PYP_EDUCATOR_CENTER_V2",

        "PYP_PROGRESS_REPORTS",
        "PYP_ADMIN_GRADEBOOK",
        "PYP_ATTENDANCE_DASHBOARD",
        "PYP_SETTINGS",
        "PYP_TIMETABLE",
        "PYP_ATTENDANCE_AND_TIMETABLE_SETTINGS",
        "PYP_WORKSHEET_QUESTION_LIBRARY",
        "PYP_TRASH",
        "PYP_TIMETABLE_MANAGER",
        "PYP_NOTIFICATIONS_MANAGER",
        "PYP_ESF_SENTRAL_WELLBEING",
        "PYP_ESF_SENTRAL_TIMETABLE",
        "PYP_ESF_SENTRAL_ATTENDANCE",
        "PYP_ESF_SENTRAL_POLICIES",
      ],
      curriculumPrograms: ["IB_PYP"],
      levelId: "L0",
      isDynamicNode: true,
      skipRolesAndPermissionsCheck: true,
      isProgramRootNode: true,
    },
    {
      id: "IB_MYP",
      label: "common:myp",
      children: [
        "MYP_ACADEMIC_SETUP",
        "MYP_SNP",
        "SUBJECT_SUMMARY",
        "MYP_EDUCATOR_CENTER",
        "MYP_EDUCATOR_CENTER_V2",
        "MYP_PROGRESS_REPORTS",
        "MYP_ADMIN_GRADEBOOK",
        "MYP_ATTENDANCE_DASHBOARD",

        "MYP_SETTINGS",
        "MYP_TIMETABLE",
        "MYP_ATTENDANCE_AND_TIMETABLE_SETTINGS",
        "MYP_WORKSHEET_QUESTION_LIBRARY",
        "MYP_TRASH",
        "MYP_TIMETABLE_MANAGER",
        "MYP_NOTIFICATIONS_MANAGER",
        "MYP_ESF_SENTRAL_WELLBEING",
        "MYP_ESF_SENTRAL_TIMETABLE",
        "MYP_ESF_SENTRAL_ATTENDANCE",
        "MYP_ESF_SENTRAL_POLICIES",
      ],
      curriculumPrograms: ["IB_MYP"],
      levelId: "L0",
      isDynamicNode: true,
      skipRolesAndPermissionsCheck: true,
      isProgramRootNode: true,
    },
    {
      id: "UBD",
      label: "common:ubd",
      children: [
        "UBD_ACADEMIC_SETUP",
        "UBD_SNP",
        "UBD_EDUCATOR_CENTER",
        "UBD_EDUCATOR_CENTER_V2",
        "UBD_PROGRESS_REPORTS",
        "UBD_ADMIN_GRADEBOOK",
        "UBD_ATTENDANCE_DASHBOARD",

        "UBD_SETTINGS",
        "UBD_TIMETABLE",
        "UBD_ATTENDANCE_AND_TIMETABLE_SETTINGS",
        "UBD_WORKSHEET_QUESTION_LIBRARY",
        "UBD_TRASH",
        "UBD_TIMETABLE_MANAGER",
        "UBD_NOTIFICATIONS_MANAGER",
        "UBD_ESF_SENTRAL_WELLBEING",
        "UBD_ESF_SENTRAL_TIMETABLE",
        "UBD_ESF_SENTRAL_ATTENDANCE",
        "UBD_ESF_SENTRAL_POLICIES",
      ],
      curriculumPrograms: ["UBD"],
      levelId: "L0",
      isDynamicNode: true,
      skipRolesAndPermissionsCheck: true,
      isProgramRootNode: true,
    },
    {
      id: "POI",
      label: "teacherHomePage:poi",
      children: [],
      perm: "AdminPortal:POI",
      route: "poi",
      levelId: "L1",
      icon: <AicnPOI />,
    },
    {
      id: "PYP_SNP",
      label: "teacherHomePage:authorizationEvaluation",
      children: [],
      permission: SNPv2_ACCESS_PERMISSION,
      route: "snp_v2",
      levelId: "L1",
      icon: <IconAvatar icon={PolicyTickOutlined} color="pink" />,
      isDynamicNode: true,
    },
    {
      id: "MYP_SNP",
      label: "teacherHomePage:authorizationEvaluation",
      children: [],
      permission: SNPv2_ACCESS_PERMISSION,
      route: "snp_v2",
      levelId: "L1",
      icon: <IconAvatar icon={PolicyTickOutlined} color="violet" />,
      isDynamicNode: true,
    },
    {
      id: "UBD_SNP",
      label: "teacherHomePage:authorizationEvaluation",
      children: [],
      permission: SNPv2_ACCESS_PERMISSION,
      route: "snp_v2",
      levelId: "L1",
      icon: <IconAvatar icon={PolicyTickOutlined} color="teal" />,
      isDynamicNode: true,
    },
    {
      id: "DP_SNP",
      label: "teacherHomePage:authorizationEvaluation",
      children: [],
      permission: SNPv2_ACCESS_PERMISSION,
      route: "snp_v2",
      levelId: "L1",
      icon: <IconAvatar icon={PolicyTickOutlined} color="yellow" />,
      isDynamicNode: true,
    },
    {
      id: "PYP_PROGRESS_REPORTS",
      label: "common:progress_reports",
      children: [
        "CHECKLIST",
        "PROGRESS_REPORTS_TASKS",
        "PROGRESS_REPORT_TEMPLATE",
        "SAVED_COMMENT_TEMPLATES",
        "VOICE_AND_OUTPUT_STRUCTURE",
      ],
      route: "progressreports",
      permission: PROGRESS_REPORTS_ADMIN_LEVEL_VIEW_PERMISSION,
      levelId: "L1",
      curriculumPrograms: [CURRICULUM_TYPE_PYP],
      icon: <IconAvatar icon={ProgressReportOutlined} color="pink" />,
      isDynamicNode: true,
    },
    {
      id: "PROGRESS_REPORTS_TASKS",
      label: "progressReport:report_set_plural",
      children: [],
      permission: PROGRESS_REPORTS_ADMIN_LEVEL_VIEW_PERMISSION,
      route: "reporttasks",
      levelId: "L2",
    },
    {
      id: "SAVED_COMMENT_TEMPLATES",
      label: "teacherHomePage:comments_bank",
      children: [],
      permission: PROGRESS_REPORTS_ADMIN_LEVEL_VIEW_PERMISSION,
      route: "comment-templates",
    },
    {
      id: "VOICE_AND_OUTPUT_STRUCTURE",
      label: "teacherHomePage:voice_and_output_heading",
      children: [],
      perm: "Common:ChatGPTPoweredTextFeatures",
      subtext: "common:toddle_ai",
      route: "voice-and-output-structure",
    },
    {
      id: "CHECKLIST",
      label: "teacherHomePage:checklist",
      children: [],
      permission: PROGRESS_REPORTS_ADMIN_LEVEL_VIEW_PERMISSION,
      route: "checklist",
      levelId: "L2",
    },
    {
      id: "CHECKLIST_V2",
      label: "teacherHomePage:checklist",
      children: [],
      permission: PROGRESS_REPORTS_ADMIN_LEVEL_VIEW_PERMISSION,
      perm: "FeatureFlag:isReportRevampPhase2Enabled",
      route: "checklist",
      levelId: "L2",
    },
    {
      id: "MYP_PROGRESS_REPORTS",
      label: "common:progress_reports",
      children: [
        "CHECKLIST_V2",
        "MYP_PROGRESS_REPORTS_TASKS",
        "MYP_PROGRESS_REPORT_TEMPLATE",
        "SAVED_COMMENT_TEMPLATES",
        "VOICE_AND_OUTPUT_STRUCTURE",
      ],
      route: "progressreports",
      permission: PROGRESS_REPORTS_ADMIN_LEVEL_VIEW_PERMISSION,
      levelId: "L1",
      curriculumPrograms: ["IB_MYP"],
      icon: <IconAvatar icon={ProgressReportOutlined} color="violet" />,
      isDynamicNode: true,
    },
    {
      id: "DP_PROGRESS_REPORTS",
      label: "common:progress_reports",
      children: [
        "CHECKLIST_V2",
        "DP_PROGRESS_REPORTS_TASKS",
        "DP_PROGRESS_REPORT_TEMPLATE",
        "SAVED_COMMENT_TEMPLATES",
        "VOICE_AND_OUTPUT_STRUCTURE",
      ],
      route: "progressreports",
      levelId: "L1",
      curriculumPrograms: ["IB_DP"],
      icon: <IconAvatar icon={ProgressReportOutlined} color="yellow" />,
      isDynamicNode: true,
      permission: PROGRESS_REPORTS_ADMIN_LEVEL_VIEW_PERMISSION,
    },
    {
      id: "DP_PROGRESS_REPORTS_TASKS",
      label: "progressReport:report_set_plural",
      children: [],
      permission: PROGRESS_REPORTS_ADMIN_LEVEL_VIEW_PERMISSION,
      route: "reporttasks",
      levelId: "L2",
    },
    {
      id: "DP_PROGRESS_REPORT_TEMPLATE",
      label: "progressReport:report_templates_label",
      children: [],
      levelId: "L2",
      route: "progressreporttemplate",
      permission: PROGRESS_REPORTS_ADMIN_LEVEL_VIEW_PERMISSION,
    },
    {
      id: "UBD_PROGRESS_REPORTS",
      label: "common:progress_reports",
      children: [
        "CHECKLIST_V2",
        "UBD_PROGRESS_REPORTS_TASKS",
        "UBD_PROGRESS_REPORT_TEMPLATE",
        "SAVED_COMMENT_TEMPLATES",
        "VOICE_AND_OUTPUT_STRUCTURE",
      ],
      route: "progressreports",
      permission: PROGRESS_REPORTS_ADMIN_LEVEL_VIEW_PERMISSION,
      levelId: "L1",
      curriculumPrograms: ["UBD"],
      icon: <IconAvatar icon={ProgressReportOutlined} color="teal" />,
      isDynamicNode: true,
    },
    {
      id: "DP_CORE_SETUP",
      label: "teacherHomePage:dp_core_setup",
      children: ["YEAR_GROUP_OVERVIEW", "MEMBERSHIP_STUDENTS"],
      levelId: "L1",
      perm: "AdminPortal:DPCoreSetup",
      route: "project-group-setup",
      curriculumPrograms: [CURRICULUM_TYPE_DP],
      icon: <IconAvatar icon={ProgressReportOutlined} color="yellow" />,
      isDynamicNode: true,
      skipForTeacher: true,
    },
    {
      id: "DP_IBIS_EXAM_REGISTRATION",
      label: "teacherHomePage:ibis_exam_registration",
      children: ["CLASS", "IBIS_SETTINGS"],
      levelId: "L1",
      permission: IBIS_REGISTRATION_ACCESS_PERMISSION,
      route: "exam-registration",
      curriculumPrograms: [CURRICULUM_TYPE_DP],
      icon: <IconAvatar icon={ClipboardPencilLinesOutlined} color="yellow" />,
      isDynamicNode: true,
    },
    {
      id: "DP_IBIS_REGISTRATION",
      label: "teacherHomePage:ibis_exam_registration",
      children: [],
      levelId: "L1",
      permission: IBIS_REGISTRATION_ACCESS_PERMISSION,
      route: "ibis-registration",
      curriculumPrograms: [CURRICULUM_TYPE_DP],
      icon: <IconAvatar icon={ClipboardPencilLinesOutlined} color="yellow" />,
      isDynamicNode: true,
    },
    {
      id: "DP_IB_E_COURSEWORK",
      label: "teacherHomePage:ib_ecoursework",
      children: [],
      levelId: "L1",
      permission: ENABLE_IBECOURSEWORK,
      route: "ecoursework",
      curriculumPrograms: [CURRICULUM_TYPE_DP],
      icon: <IconAvatar icon={SpiralBookLinesOutlined} color="yellow" />,
      isDynamicNode: true,
      rolesAndPermissionKey: "IB_ECOURSEWORK",
    },
    {
      id: "DP_ACADEMIC_SETUP",
      label: "teacherHomePage:academic_setup",
      children: [
        "SUBJECTS_SECTION_DP",
        "LPA_DP",
        "APPROACHES_TO_LEARNING_DP",
        "GRADING_V2",
        "DP_GRADING",
        "ACADEMIC_ASSESSMENTS_DP",
        "ACADEMIC_TEMPLATES_DP",
      ],
      curriculumPrograms: [CURRICULUM_TYPE_DP],
      permission: ACADEMIC_SETUP_VIEW_PERM,
      levelId: "L1",
      route: "dpAcademicSetup",
      icon: <IconAvatar icon={SetupOutlined} color="yellow" />,
      isDynamicNode: true,
      showBreadCrumb: false,
    },
    {
      id: "SUBJECTS_SECTION_DP",
      label: "common:subject_plural",
      children: [
        "DP_SUBJECTS",
        "DP_SUBJECT_STANDARD",
        "DP_STANDARDS_V2",
        "DATASETS_V2",
        "DP_EE_SUBJECTS",
        "DP_CONTINUUM",
      ],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: [CURRICULUM_TYPE_DP],
    },
    {
      id: "APPROACHES_TO_LEARNING_DP",
      label: "common:learning_goals",
      children: ["DP_ATL"],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: [CURRICULUM_TYPE_DP],
    },
    {
      id: "LPA_DP",
      label: "common:lpas",
      children: ["DP_LEARNER_PROFILE"],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: [CURRICULUM_TYPE_DP],
    },
    {
      id: "DP_LEARNER_PROFILE",
      label: "common:learner_profile_attributes",
      children: [],
      levelId: "L3",
      route: "learner-profile-attributes",
      perm: "AdminPortal:DPLearnerProfile",
    },
    {
      id: "ACADEMIC_ASSESSMENTS_DP",
      label: "common:assessment_label_plural",
      children: [
        "DP_ASSESSMENT_SETUP",
        "DP_SCORE_CATEGORIES",
        "DP_SCORE_CATEGORIES_V2",
        "DP_TERM_GRADE_BOUNDARIES",
        "DP_LOCAL_GRADES",
        "DP_EVALUATION_CRITERIA",
        "DP_ASSESSMENT_CRITERIA",
      ],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: [CURRICULUM_TYPE_DP],
    },
    {
      id: "DP_GRADING",
      label: "common:grading",
      children: [
        "DP_GRADING_PERIODS",
        "DP_GRADING_SETUP",
        "DP_ASSESSMENT_SETTINGS_EVALUATION_CRITERIA",
        "DP_OVERALL_PROGRESS_INDICATORS",
        "DP_GPA_AND_CREDITS",
      ],
      levelId: "L2",
      isSubsection: true,
    },
    {
      id: "DP_GRADING_PERIODS",
      label: "common:grading_period_plural",
      children: [],
      levelId: "L2",
      route: "grading-periods",
      perm: "AdminPortal:GradingPeriods",
    },
    {
      id: "DP_OVERALL_PROGRESS_INDICATORS",
      label: "project:project_progress_markers",
      children: [],
      levelId: "L2",
      route: "project-progress-indicators",
      isPermNegated: true,
    },
    {
      id: "DP_GRADING_SETUP",
      label: "academicSetup:grading_setup",
      children: [
        "DP_OVERALL_SETUP",
        "DP_OVERALL_SETUP-divider",
        "DP_ASSESSMENTS_SETUP",
        "DP_CUMULATIVE_SCORE_SETUP",
        "DP_GRADE_BOUNDARY_SETUP",
        "DP_LOCAL_GRADE_SETUP",
        "DP_AGGREGATE_SETUP",
        "DP_NOMENCLATURE_SETUP-divider",
        "DP_NOMENCLATURE_SETUP",
      ],
      levelId: "L2",
      route: "grading-setup",
      hasSubTabs: true,
      perm: "AdminPortal:AssessmentSettings",
    },
    {
      id: "DP_ASSESSMENT_SETTINGS_EVALUATION_CRITERIA",
      label: "academicSetup:evaluation_criteria",
      children: [
        "DP_CREATE_EVALUATION_CRITERIA",
        "DP_MAP_EVALUATION_CRITERIA",
        "DP_EVALUATION_CRITERIA_SETTINGS",
      ],
      levelId: "L2",
      route: "evaluation-criteria-setup",
      hasSubTabs: true,
      perm: "AdminPortal:EvaluationCriteriaV2",
    },
    {
      id: "DP_OVERALL_SETUP",
      parent: "DP_GRADING_SETUP",
      label: "academicSetup:overall_score_and_ibdp_grade_setup",
      levelId: "L3",
      children: [],
      route: "overall-setup",
      perm: "AdminPortal:AssessmentSettings",
    },
    {
      id: "DP_OVERALL_SETUP-divider",
      parent: "DP_GRADING_SETUP",
      isDivider: true,
      perm: "AdminPortal:AssessmentSettings",
      levelId: "L3",
    },
    {
      id: "DP_NOMENCLATURE_SETUP-divider",
      parent: "DP_GRADING_SETUP",
      isDivider: true,
      perm: "FeatureFlag:EnableNomenclatureForCriteriaSet",
      levelId: "L3",
    },
    {
      id: "DP_ASSESSMENTS_SETUP",
      parent: "DP_GRADING_SETUP",
      label: "progressSummary:assessments",
      levelId: "L3",
      children: [],
      route: "assessment-setup",
      perm: "AdminPortal:AssessmentCategoriesV2",
    },
    {
      id: "DP_CUMULATIVE_SCORE_SETUP",
      parent: "DP_GRADING_SETUP",
      label: "academicSetup:cumulative_scores",
      levelId: "L3",
      children: [],
      route: "cumulative-score-setup",
      perm: "AdminPortal:ShowCumulativeColumns",
    },
    {
      id: "DP_GRADE_BOUNDARY_SETUP",
      parent: "DP_GRADING_SETUP",
      label: "academicSetup:ibdp_grade_boundaries",
      levelId: "L3",
      children: [],
      route: "grade-boundary-setup",
      perm: "AdminPortal:GradeBoundarySetup",
    },
    {
      id: "DP_LOCAL_GRADE_SETUP",
      parent: "DP_GRADING_SETUP",
      label: "common:local_grades",
      levelId: "L3",
      children: [],
      route: "local-grade-setup",
      perm: "AdminPortal:LocalGradeSetup",
    },
    {
      id: "DP_NOMENCLATURE_SETUP",
      parent: "DP_GRADING_SETUP",
      label: "common:nomenclature",
      levelId: "L3",
      children: [],
      route: "nomenclature-setup",
      perm: "FeatureFlag:EnableNomenclatureForCriteriaSet",
    },
    {
      id: "DP_AGGREGATE_SETUP",
      parent: "DP_GRADING_SETUP",
      label: "academicSetup:score_and_grade_aggregation",
      levelId: "L3",
      children: [],
      route: "aggregate-setup",
      perm: "FeatureFlag:ScoreAndGradeAggregation",
    },
    {
      id: "DP_CREATE_EVALUATION_CRITERIA",
      parent: "DP_ASSESSMENT_SETTINGS_EVALUATION_CRITERIA",
      label: "academicSetup:create_evaluation_criteria",
      levelId: "L3",
      children: [],
      route: "create-evaluation-criteria",
      perm: "AdminPortal:EvaluationCriteriaV2",
    },
    {
      id: "DP_MAP_EVALUATION_CRITERIA",
      parent: "DP_ASSESSMENT_SETTINGS_EVALUATION_CRITERIA",
      label: "academicSetup:map_evaluation_criteria",
      levelId: "L3",
      children: [],
      route: "map-evaluation-criteria",
      perm: "AdminPortal:AssessmentCriteriaV2",
    },
    {
      id: "DP_EVALUATION_CRITERIA_SETTINGS",
      parent: "DP_ASSESSMENT_SETTINGS_EVALUATION_CRITERIA",
      label: "common:settings",
      levelId: "L3",
      children: [],
      route: "settings",
      perm: "AdminPortal:EvaluationCriteriaSettings",
    },
    {
      id: "DP_ASSESSMENT_SETUP",
      label: "academicSetup:assessment_setup",
      children: [],
      levelId: "L2",
      route: "assessment-setup",
      perm: "AdminPortal:DPScoreCategoriesV2",
    },
    {
      id: "DP_SCORE_CATEGORIES",
      label: "common:point_based_assessment",
      children: [],
      levelId: "L2",
      route: "score-categories",
      perm: "AdminPortal:DPScoreCategories",
    },
    {
      id: "DP_LOCAL_GRADES",
      label: "common:local_grades",
      children: [],
      levelId: "L2",
      route: "local-grades",
      perm: "AdminPortal:DPLocalGrades",
    },
    {
      id: "DP_SCORE_CATEGORIES_V2",
      label: "academicSetup:assessment_categories",
      children: [],
      levelId: "L2",
      route: "assessment-categories",
      perm: "AdminPortal:DPScoreCategoriesV2",
    },
    {
      id: "DP_TERM_GRADE_BOUNDARIES",
      label: "academicSetup:grade_boundaries",
      children: [],
      levelId: "L2",
      route: "grade-boundaries",
      perm: "AdminPortal:DPTermGradeBoundaries",
    },
    {
      id: "DP_EVALUATION_CRITERIA",
      label: "academicSetup:evaluation_criteria",
      children: [],
      levelId: "L3",
      route: "evaluation-criteria",
      perm: "AdminPortal:DPEvaluationCriteria",
    },
    {
      id: "DP_ASSESSMENT_CRITERIA",
      label: "academicSetup:map_evaluation_criteria",
      children: [],
      levelId: "L3",
      route: "assessment-criteria",
      perm: "AdminPortal:DPAssessmentCriteria",
    },
    {
      id: "DP_SUBJECTS",
      label: "common:subject_plural",
      children: [],
      levelId: "L3",
      route: "subjects",
      perm: "AdminPortal:Subjects",
    },
    {
      id: "DP_EE_SUBJECTS",
      label: "common:extended_essay_subjects",
      children: [],
      levelId: "L3",
      route: "eeSubjects",
      perm: "AdminPortal:EESubjectRoster",
    },
    {
      id: "DP_SUBJECT_STANDARD",
      label: "common:content_standards",
      children: [],
      isDynamicPlannerElementLabel: true,
      dynamicPlannerElementLabelPerm: ENABLE_DP_DYNAMIC_PLANNER_ELEMENT_LABEL,
      plannerElementType: "DP_SUBJECT_STANDARD",
      levelId: "L2",
      route: "dp-learning-standards",
      perm: "AdminPortal:DPLearningStandards",
    },
    {
      id: "ACADEMIC_TEMPLATES_DP",
      label: "common:template_plural",
      children: [
        "WORKBOOK_TEMPLATES_MYP_DP",
        "DP_ASSESSMENT_TOOL_V2",
        "STUDENT_PROFILE_TEMPLATES",
        "DATA_SETS",
        "FIELDS",
        "MANAGE_TEMPLATES",
        "DP_ROUTINE_AND_MEAL_TEMPLATES",
      ],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: ["IB_DP"],
    },
    {
      id: "YEAR_GROUP_OVERVIEW",
      label: "common:overview",
      children: [],
      levelId: "L2",
      perm: "AdminPortal:YearGroupManager",
      route: "overview",
    },
    // For Future reference where we'll have multi tabs in membership tab.
    // {
    //   id: "YEAR_GROUP_MEMBERSHIP",
    //   label: "common:membership",
    //   levelId: "L2",
    //   perm: "AdminPortal:YearGroupMembership",
    //   route: "membership",
    //   subMenu: ["MEMBERSHIP_STUDENTS"],
    // },
    {
      id: "MEMBERSHIP_STUDENTS",
      label: "common:student_plural",
      children: [],
      levelId: "L2",
      route: "membership",
      perm: "AdminPortal:YearGroupManager",
    },
    {
      id: "MYP_PROGRESS_REPORTS_TASKS",
      label: "progressReport:report_set_plural",
      children: [],
      permission: PROGRESS_REPORTS_ADMIN_LEVEL_VIEW_PERMISSION,
      route: "reporttasks",
      levelId: "L2",
    },
    {
      id: "MYP_PROGRESS_REPORT_TEMPLATE",
      label: "progressReport:report_templates_label",
      children: [],
      levelId: "L2",
      route: "progressreporttemplate",
      permission: PROGRESS_REPORTS_ADMIN_LEVEL_VIEW_PERMISSION,
    },
    {
      id: "UBD_PROGRESS_REPORTS_TASKS",
      label: "progressReport:report_set_plural",
      children: [],
      permission: PROGRESS_REPORTS_ADMIN_LEVEL_VIEW_PERMISSION,
      route: "reporttasks",
      levelId: "L2",
    },
    {
      id: "UBD_PROGRESS_REPORT_TEMPLATE",
      label: "progressReport:report_templates_label",
      children: [],
      levelId: "L2",
      route: "progressreporttemplate",
      permission: PROGRESS_REPORTS_ADMIN_LEVEL_VIEW_PERMISSION,
    },
    {
      id: "PYP_EDUCATOR_CENTER",
      label: "teacherHomePage:educator_center",
      children: ["RESOURCES", "POLICIES"],
      levelId: "L1",
      route: "educatorcenter",
      curriculumPrograms: ["IB_PYP"],
      icon: <IconAvatar icon={OpenBookTextOutlined} color={"pink"} />,
      isDynamicNode: true,
      rolesAndPermissionKey: "EDUCATOR_CENTER",
    },
    {
      id: "PYP_EDUCATOR_CENTER_V2",
      label: "common:school_policies_and_resources",
      children: [],
      permission: VIEW_SCHOOL_POLICIES_AND_RESOURCES_MODULE_PERMISSION,
      levelId: "L1",
      route: "educatorcenter_v2",
      curriculumPrograms: ["IB_PYP"],
      icon: <IconAvatar icon={OpenBookTextOutlined} color="pink" />,
      isDynamicNode: true,
      rolesAndPermissionKey: "EDUCATOR_CENTER",
    },
    {
      id: "MYP_EDUCATOR_CENTER_V2",
      label: "common:school_policies_and_resources",
      children: [],
      permission: VIEW_SCHOOL_POLICIES_AND_RESOURCES_MODULE_PERMISSION,

      levelId: "L1",
      route: "educatorcenter_v2",
      curriculumPrograms: ["IB_MYP"],
      icon: <IconAvatar icon={OpenBookTextOutlined} color="violet" />,
      isDynamicNode: true,
      rolesAndPermissionKey: "EDUCATOR_CENTER",
    },
    {
      id: "UBD_EDUCATOR_CENTER_V2",
      label: "common:school_policies_and_resources",
      children: [],
      permission: VIEW_SCHOOL_POLICIES_AND_RESOURCES_MODULE_PERMISSION,

      levelId: "L1",
      route: "educatorcenter_v2",
      curriculumPrograms: ["UBD"],
      icon: <IconAvatar icon={OpenBookTextOutlined} color="teal" />,
      isDynamicNode: true,
      rolesAndPermissionKey: "EDUCATOR_CENTER",
    },
    {
      id: "DP_EDUCATOR_CENTER_V2",
      label: "common:school_policies_and_resources",
      children: [],
      permission: VIEW_SCHOOL_POLICIES_AND_RESOURCES_MODULE_PERMISSION,

      levelId: "L1",
      route: "educatorcenter_v2",
      curriculumPrograms: ["IB_DP"],
      icon: <IconAvatar icon={OpenBookTextOutlined} color="yellow" />,
      isDynamicNode: true,
      rolesAndPermissionKey: "EDUCATOR_CENTER",
    },
    {
      id: "MYP_EDUCATOR_CENTER",
      label: "teacherHomePage:educator_center",
      children: ["RESOURCES", "POLICIES"],
      levelId: "L1",
      route: "educatorcenter",
      curriculumPrograms: ["IB_MYP"],
      icon: <IconAvatar icon={OpenBookTextOutlined} color={"violet"} />,
      isDynamicNode: true,
      rolesAndPermissionKey: "EDUCATOR_CENTER",
    },
    {
      id: "UBD_EDUCATOR_CENTER",
      label: "teacherHomePage:educator_center",
      children: ["RESOURCES", "POLICIES"],
      levelId: "L1",
      route: "educatorcenter",
      curriculumPrograms: ["UBD"],
      icon: <IconAvatar icon={OpenBookTextOutlined} color={"teal"} />,
      isDynamicNode: true,
      rolesAndPermissionKey: "EDUCATOR_CENTER",
    },
    {
      id: "DP_EDUCATOR_CENTER",
      label: "teacherHomePage:educator_center",
      children: ["RESOURCES", "POLICIES"],
      levelId: "L1",
      route: "educatorcenter",
      curriculumPrograms: ["IB_DP"],
      icon: <IconAvatar icon={OpenBookTextOutlined} color={"yellow"} />,
      isDynamicNode: true,
      rolesAndPermissionKey: "EDUCATOR_CENTER",
    },
    {
      id: "CLASS",
      label: "common:class",
      children: [
        "IBIS_EXAM_REGISTRATION_OVERVIEW",
        "IBIS_EXAM_CANDIDATE_INFO",
        "IBIS_EXAM_SUBJECTS",
        "IBIS_EXAM_DETAILS",
      ],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: ["IB_DP"],
      permission: IBIS_REGISTRATION_ACCESS_PERMISSION,
    },
    {
      id: "PYP_WORKSHEET_QUESTION_LIBRARY",
      label: "worksheet:question_library",
      levelId: "L1",
      children: [],
      route: "question-library",
      curriculumPrograms: ["IB_PYP"],
      isDynamicNode: true,
      icon: <IconAvatar icon={SetupOutlined} color="pink" />,
      perm: "AdminPortal:QuestionLibrary",
      rolesAndPermissionKey: "QUESTION_LIBRARY",
    },
    {
      id: "PYP_TRASH",
      label: "common:trash",
      levelId: "L1",
      children: [
        "TRASH_LEARNING_COURSES",
        "TRASH_UNIT_PLANS",
        "TRASH_LEARNING_EXPERIENCES",
        "TRASH_ORG_STUDENTS",
        "TRASH_PROGRESS_REPORT_SETS",
        "TRASH_CLASS_PLANNERS",
      ],
      route: "trash",
      isDynamicNode: true,
      curriculumPrograms: ["IB_PYP"],
      icon: <IconAvatar icon={DeleteOutlined} color="pink" />,
      permission: BIN_ACCESS_PERM,
      checkOnlyForParentPermission: true,
    },
    {
      id: "MYP_TRASH",
      label: "common:trash",
      levelId: "L1",
      children: [
        "TRASH_LEARNING_COURSES",
        "TRASH_UNIT_PLANS",
        "TRASH_LEARNING_EXPERIENCES",
        "TRASH_ORG_STUDENTS",
        "TRASH_PROGRESS_REPORT_SETS",
        "TRASH_CLASS_PLANNERS",
      ],
      route: "trash",
      curriculumPrograms: ["IB_MYP"],
      icon: <IconAvatar icon={DeleteOutlined} color="violet" />,
      isDynamicNode: true,
      permission: BIN_ACCESS_PERM,
      checkOnlyForParentPermission: true,
    },
    {
      id: "UBD_TRASH",
      label: "common:trash",
      levelId: "L1",
      children: [
        "TRASH_LEARNING_COURSES",
        "TRASH_UNIT_PLANS",
        "TRASH_LEARNING_EXPERIENCES",
        "TRASH_ORG_STUDENTS",
        "TRASH_PROGRESS_REPORT_SETS",
        "TRASH_CLASS_PLANNERS",
      ],
      route: "trash",
      curriculumPrograms: ["UBD"],
      icon: <IconAvatar icon={DeleteOutlined} color="teal" />,
      isDynamicNode: true,
      permission: BIN_ACCESS_PERM,
      checkOnlyForParentPermission: true,
    },
    {
      id: "DP_TRASH",
      label: "common:trash",
      levelId: "L1",
      children: [
        "TRASH_LEARNING_COURSES",
        "TRASH_UNIT_PLANS",
        "TRASH_LEARNING_EXPERIENCES",
        "TRASH_ORG_STUDENTS",
        "TRASH_PROGRESS_REPORT_SETS",
        "TRASH_CLASS_PLANNERS",
      ],
      route: "trash",
      curriculumPrograms: ["IB_DP"],
      icon: <IconAvatar icon={DeleteOutlined} color="yellow" />,
      permission: BIN_ACCESS_PERM,
      isDynamicNode: true,
      checkOnlyForParentPermission: true,
    },
    {
      id: "PYP_TIMETABLE_MANAGER",
      label: "Timetable Manager",
      levelId: "L1",
      route: "timetable-manager",
      curriculumPrograms: ["IB_PYP"],
      icon: <IconAvatar icon={SetupOutlined} color="pink" />,
      perm: "FeatureFlag:Toddle2.0Timetable",
      isDynamicNode: true,
      checkOnlyForParentPermission: true,
    },
    {
      id: "MYP_TIMETABLE_MANAGER",
      label: "Timetable Manager",
      levelId: "L1",
      route: "timetable-manager",
      curriculumPrograms: ["IB_MYP"],
      icon: <IconAvatar icon={SetupOutlined} color="violet" />,
      perm: "FeatureFlag:Toddle2.0Timetable",
      isDynamicNode: true,
      checkOnlyForParentPermission: true,
    },
    {
      id: "UBD_TIMETABLE_MANAGER",
      label: "Timetable Manager",
      levelId: "L1",
      route: "timetable-manager",
      curriculumPrograms: ["UBD"],
      icon: <IconAvatar icon={SetupOutlined} color="teal" />,
      perm: "FeatureFlag:Toddle2.0Timetable",
      isDynamicNode: true,
      checkOnlyForParentPermission: true,
    },
    {
      id: "DP_TIMETABLE_MANAGER",
      label: "Timetable Manager",
      levelId: "L1",
      route: "timetable-manager",
      curriculumPrograms: ["IB_DP"],
      icon: <IconAvatar icon={SetupOutlined} color="yellow" />,
      perm: "FeatureFlag:Toddle2.0Timetable",
      isDynamicNode: true,
      checkOnlyForParentPermission: true,
    },
    {
      id: "MYP_WORKSHEET_QUESTION_LIBRARY",
      label: "worksheet:question_library",
      levelId: "L1",
      children: [],
      route: "question-library",
      curriculumPrograms: ["IB_MYP"],
      isDynamicNode: true,
      icon: <IconAvatar icon={SetupOutlined} color="violet" />,
      perm: "AdminPortal:QuestionLibrary",
      rolesAndPermissionKey: "QUESTION_LIBRARY",
    },
    {
      id: "DP_WORKSHEET_QUESTION_LIBRARY",
      label: "worksheet:question_library",
      levelId: "L1",
      children: [],
      route: "question-library",
      curriculumPrograms: ["IB_DP"],
      isDynamicNode: true,
      icon: <IconAvatar icon={SetupOutlined} color="yellow" />,
      perm: "AdminPortal:QuestionLibrary",
      rolesAndPermissionKey: "QUESTION_LIBRARY",
    },
    {
      id: "UBD_WORKSHEET_QUESTION_LIBRARY",
      label: "worksheet:question_library",
      levelId: "L1",
      children: [],
      route: "question-library",
      curriculumPrograms: ["UBD"],
      isDynamicNode: true,
      icon: <IconAvatar icon={SetupOutlined} color="teal" />,
      perm: "AdminPortal:QuestionLibrary",
      rolesAndPermissionKey: "QUESTION_LIBRARY",
    },
    {
      id: "IBIS_SETTINGS",
      label: "teacherHomePage:ibis_settings",
      children: ["IBIS_EXAM_PERMISSION", "IBIS_EXAM_SYNC"],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: ["IB_DP"],
      permission: IBIS_REGISTRATION_ACCESS_PERMISSION,
    },
    {
      id: "IBIS_EXAM_REGISTRATION_OVERVIEW",
      label: "teacherHomePage:ibis_exam_registration_overview",
      children: [],
      levelId: "L3",
      route: "overview",
      permission: IBIS_REGISTRATION_ACCESS_PERMISSION,
    },
    {
      id: "IBIS_EXAM_CANDIDATE_INFO",
      label: "teacherHomePage:ibis_exam_candidate_info",
      children: [],
      levelId: "L3",
      route: "candidate-info",
      permission: IBIS_REGISTRATION_ACCESS_PERMISSION,
    },
    {
      id: "IBIS_EXAM_SUBJECTS",
      label: "common:subject_plural",
      children: [],
      levelId: "L3",
      route: "subjects",
      permission: IBIS_REGISTRATION_ACCESS_PERMISSION,
    },
    {
      id: "IBIS_EXAM_DETAILS",
      label: "teacherHomePage:ibis_exam_details",
      children: [],
      levelId: "L3",
      route: "exam-details",
      permission: IBIS_REGISTRATION_ACCESS_PERMISSION,
    },
    {
      id: "IBIS_EXAM_PERMISSION",
      label: "common:permission_plural",
      subLabel: "common:ibis_perm_sub_label",
      children: [],
      levelId: "L3",
      route: "permissions",
      permission: IBIS_REGISTRATION_ACCESS_PERMISSION,
    },
    {
      id: "IBIS_EXAM_SYNC",
      label: "integration:sync",
      subLabel: "common:ibis_sync_sub_label",
      children: [],
      levelId: "L3",
      route: "sync",
      permission: IBIS_REGISTRATION_ACCESS_PERMISSION,
    },
    {
      id: "RESOURCES",
      label: "common:resources",
      children: [
        "TEACHER_RESOURCE",
        "STUDENT_RESOURCE",
        "PARENT_RESOURCE",
        "ADMIN_RESOURCE",
        "WORKBOOK_TEMPLATE",
      ],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: ["IB_PYP", "IB_MYP", "UBD", "IB_DP"],
    },
    {
      id: "POLICIES",
      label: "common:school_policy",
      children: [
        "TEACHER_SCHOOL_POLICIES",
        "STUDENT_SCHOOL_POLICIES",
        "PARENT_SCHOOL_POLICIES",
      ],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: ["IB_PYP", "IB_MYP", "UBD", "IB_DP"],
    },
    {
      id: "TEACHER_SCHOOL_POLICIES",
      label: "teacherHomePage:shared_with_teachers",
      children: [],
      levelId: "L3",
      route: "teacherpolicies",
      perm: "AdminPortal:TeacherSchoolPolicies",
    },
    {
      id: "STUDENT_SCHOOL_POLICIES",
      label: "teacherHomePage:shared_with_students",
      children: [],
      levelId: "L3",
      route: "studentpolicies",
      perm: "Common:StudentSchoolPolicies",
    },
    {
      id: "PARENT_SCHOOL_POLICIES",
      label: "teacherHomePage:shared_with_parents",
      children: [],
      levelId: "L3",
      route: "parentpolicies",
      perm: "AdminPortal:ParentSchoolPolicies",
    },
    {
      id: "ADMIN_RESOURCE",
      label: "teacherHomePage:admin_resources_sentence_case",
      children: [],
      levelId: "L3",
      route: "adminresources",
      perm: "AdminPortal:AdminResources",
    },
    {
      id: "TEACHER_RESOURCE",
      label: "teacherHomePage:teacher_resources_sentence_case",
      children: [],
      levelId: "L3",
      route: "teacherresources",
      perm: "AdminPortal:TeacherResources",
    },
    {
      id: "STUDENT_RESOURCE",
      label: "teacherHomePage:student_resources_sentence_case",
      children: [],
      levelId: "L3",
      route: "studentresources",
      perm: "Common:StudentResources",
    },
    {
      id: "PARENT_RESOURCE",
      label: "teacherHomePage:parent_resources_sentence_case",
      children: [],
      levelId: "L3",
      route: "parentresources",
      perm: "Common:ParentResources",
    },
    {
      id: "WORKBOOK_TEMPLATE",
      label: "teacherHomePage:workbook_resources",
      children: [],
      levelId: "L3",
      route: "workbookresources",
      perm: "AdminPortal:WorkbookResource",
    },
    // {
    //   id: "SCHOOL_CALENDAR",
    //   label: "teacherHomePage:school_calendar",
    //   children: [],
    //   levelId: "L1",
    //   perm: "AdminPortal:Calendar",
    //   route: "calendar",
    //   curriculumPrograms: ["IB_PYP", "IB_MYP", "UBD", "IB_DP"],
    //   icon: <AicnCalendar />,
    // },
    {
      id: "NEWS",
      label: "teacherHomePage:news",
      children: [],
      levelId: "L1",
      route: "news",
      perm: "AdminPortal:News",
      icon: <AicnNews />,
    },
    {
      id: "CIRCULARS",
      label: "teacherHomePage:announcements",
      children: [],
      levelId: "L1",
      route: "circulars",
      curriculumPrograms: ["IB_PYP", "IB_MYP", "UBD", "IB_DP"],
      perm: "AdminPortal:Circular",
      permission: "Module:Announcements",
      icon: <Announcements3D />,
      iconBgColor: "var(--pink-900)",
      skipForTeacher: true,
    },
    {
      id: "STAFF_PERMISSIONS",
      label: "common:staff_permissions",
      children: ["ADMIN_PERMISSIONS", "TEACHER_PERMISSIONS"],
      levelId: "L1",
      route: "staff-permissions",
      perm: "AdminPortal:StaffPermissions",
      icon: <StaffPermissions3D />,
      iconBgColor: "var(--teal-900)",
      showBreadCrumb: false,
    },
    {
      id: "ROLES_AND_PERMISSIONS",
      label: "common:roles_and_permissions",
      children: [],
      levelId: "L1",
      route: "roles-and-permissions",
      permission: ENABLE_ROLES_AND_PERMISSIONS_PERMISSION,
      icon: <StaffPermissions3D />,
      iconBgColor: "var(--teal-900)",
    },
    {
      id: "MESSAGING_V2",
      label: "common:messaging",
      children: [],
      levelId: "L1",
      route: "messaging",
      onCardClick: () => {
        // to track messaging opened from admin portal in mixpanel
        recordMessagingModuleOpened({
          from: MESSAGING_MODULE_OPENED_FROM.ADMIN_PORTAL,
        });
      },
      icon: <FamilyCommunication3D />,
      iconBgColor: "var(--green-900)",
      showBreadCrumb: false,
    },
    {
      id: "GENERATE_SENTIMENT_ANALYSIS",
      label: "common:sentiment",
      children: [],
      levelId: "L1",
      onCardClick: async () => {
        // This function is behing permission and only runs for single staging org
        // to initiate sentiment analysis on demand
        try {
          await client.mutate({
            mutation: initiateSentimentAnalysisMutation,
          });
        } catch (err) {}
      },
      perm: "EnableButtonToGenerateSentimentAnalysis",
      icon: <Document3D />,
      iconBgColor: "var(--violet-900)",
      showBreadCrumb: false,
    },
    {
      id: "ADMIN_PERMISSIONS",
      label: "common:admin_permissions",
      children: ["SCHOOL_ADMIN_PERMISSION"],
      levelId: "L2",
      isSubsection: true,
    },
    {
      id: "SCHOOL_ADMIN_PERMISSION",
      label: "common:school_administrator_plural",
      children: [],
      levelId: "L3",
      route: "administrators",
      perm: "AdminPortal:StaffPermissions",
    },
    {
      id: "TEACHER_PERMISSIONS",
      label: "common:teacher_permissions",
      children: [],
      levelId: "L2",
      isSubsection: true,
      route: "teachers",
      perm: "AdminPortal:StaffPermissions",
    },
    {
      id: "MOBILE_SETTINGS",
      label: "mobile_settings",
      children: [],
      levelId: "L1",
      icon: <AicnMobileSettings />,
    },
    {
      id: "TRASH",
      label: "common:trash",
      children: [
        "TRASH_LEARNING_COURSES",
        "TRASH_UNIT_PLANS",
        "TRASH_LEARNING_EXPERIENCES",
        "TRASH_ORG_STUDENTS",
        "TRASH_PROGRESS_REPORT_SETS",
        "TRASH_CLASS_PLANNERS",
      ],
      route: "trash",
      levelId: "L1",
      icon: <Bin3D />,
      iconBgColor: "var(--purple-900)",
      skipForTeacher: true,
    },
    {
      id: "TRASH_LEARNING_COURSES",
      label: "common:trash_learning_courses",
      children: [],
      levelId: "L2",
      route: "trash-learning-courses",
      permission: BIN_ACCESS_PERM,
    },
    {
      id: "TRASH_UNIT_PLANS",
      label: "common:trash_unit_plans",
      children: [],
      levelId: "L2",
      route: "trashUnitPlans",
      permission: BIN_ACCESS_PERM,
    },
    {
      id: "TRASH_CLASS_PLANNERS",
      label: "classPlanner:class_planners",
      children: [],
      levelId: "L2",
      route: "trashClassPlanners",
      perm: "Common:ClassPlanners",
    },
    {
      id: "TRASH_LEARNING_EXPERIENCES",
      label: "common:task_plural",
      children: [],
      levelId: "L2",
      route: "trashLearningExperiences",
      permission: BIN_ACCESS_PERM,
    },
    {
      id: "TRASH_PROGRESS_REPORT_SETS",
      label: "progressReport:progress_report_set_plural",
      children: [],
      levelId: "L2",
      route: "trash-progress-report-sets",
      permission: BIN_ACCESS_PERM,
    },
    {
      id: "TRASH_ORG_STUDENTS",
      label: "common:student_plural",
      children: [],
      levelId: "L2",
      route: "trashOrganizationStudents",
      perm: "AdminPortal:StudentsTrash",
    },
    {
      id: "SCHOOL_SETUP",
      label: "teacherHomePage:school_setup",
      children: [
        "SCHOOL_SETTINGS",
        "CLASS_ROSTER",
        "INTEGRATIONS",
        "INTEGRATIONS_MODULE",
        "EXTERNAL_STAFF",
        "TOOLS",
      ],
      curriculumPrograms: ["IB_PYP", "IB_MYP", "UBD", "IB_DP"],
      route: "schoolSetup",
      levelId: "L1",
      icon: <School3D />,
      iconBgColor: "var(--yellow-900)",
      showBreadCrumb: false,
    },
    {
      id: "BEHAVIOUR_MANAGEMENT",
      label: "behaviour:behaviour_management",
      children: [],
      curriculumPrograms: ["IB_PYP", "IB_MYP", "UBD", "IB_DP"],
      levelId: "L1",
      icon: <HeadHeart3D />,
      iconBgColor: "var(--violet-900)",
      showBreadCrumb: false,
      perm: [
        ENABLE_BEHAVIOUR_MODULE_PERM,
        ENABLE_BEHAVIOUR_MODULE_IN_ADMIN_PORTAL,
      ],
      route: "behaviour-management",
      rolesAndPermissionKey: "BEHAVIOUR_MANAGEMENT",
      customPermValidator: ({
        permissions,
        curriculumConfigMap,
        curriculumProgramIds,
      }) => {
        const isSentralWellbeingEnabled = checkIsSentralFeatureEnabledInCurriculums(
          SENTRAL_PERMISSION_CONFIGURATIONS.WELLBEING,
          curriculumConfigMap,
          curriculumProgramIds
        );
        if (isSentralWellbeingEnabled) return false;
        const shouldShowBehaviourManagement = ACLStore.can(permissions);
        const isBehaviourSetupCardEnabled = getIsBehaviourSetupCardEnabled();

        return shouldShowBehaviourManagement && !isBehaviourSetupCardEnabled;
      },
    },
    {
      id: "BEHAVIOUR_CONFIGURATION",
      label: "behaviour:behaviour_management",
      children: [],
      curriculumPrograms: ["IB_PYP", "IB_MYP", "UBD", "IB_DP"],
      levelId: "L1",
      icon: <HeadHeart3D />,
      iconBgColor: "var(--violet-900)",
      showBreadCrumb: false,
      permission: BEHAVIOUR_SETUP_ACCESS_PERMISSION,
      route: "behaviour-configuration",
      perm: [
        ENABLE_BEHAVIOUR_MODULE_PERM,
        ENABLE_BEHAVIOUR_MODULE_IN_ADMIN_PORTAL,
        ENABLE_BEHAVIOUR_SETUP_CARD,
      ],
      customPermValidator: ({
        permissions,
        curriculumConfigMap,
        curriculumProgramIds,
      }) => {
        const isSentralWellbeingEnabled = checkIsSentralFeatureEnabledInCurriculums(
          SENTRAL_PERMISSION_CONFIGURATIONS.WELLBEING,
          curriculumConfigMap,
          curriculumProgramIds
        );

        if (isSentralWellbeingEnabled) return false;

        const [isBehaviourModuleEnabled, isBehaviourSetupCardEnabled] = [
          ACLStore.can(_.take(permissions, 2)),
          ACLStore.can(_.takeRight(permissions, 1)),
        ];

        const shouldShowBehaviourConfiguration =
          isBehaviourModuleEnabled && isBehaviourSetupCardEnabled;

        return shouldShowBehaviourConfiguration;
      },
    },
    {
      id: "SCHOOL_SETTINGS",
      label: "common:school_settings",
      children: [
        SCHOOL_INFORMATION,
        "OPERATIONAL_DAYS_AND_TIME_ZONE",
        "YEAR_GROUPS",
        "ACADEMIC_YEAR_TERMS",
        "GRADING_PERIODS",
        "GRADES_SETUP",
        "PERIODS_SETUP",
        "LOGIN_CONFIGURATION",
      ],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: ["IB_PYP", "IB_MYP", "UBD", "IB_DP"],
      skipForTeacher: true,
      permission: SCHOOL_OVERVIEW_ACCESS_PERMISSION,
    },
    {
      id: "CLASS_ROSTER",
      label: "schoolSetup:school_roster",
      children: [
        "LEARNING_COURSE_SETUP",
        "COURSE_SETUP",
        "TEACHER_SETUP",
        "STUDENTS",
        "FAMILY_MEMBERS",
        "USER_NAME_SETTINGS",
        "DOWNLOAD",
      ],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: ["IB_PYP", "IB_MYP", "UBD", "IB_DP"],
      accountLevelPermission: SCHOOL_ROSTER_ACCESS_PERMISSION_FOR_ACCOUNT,
      programLevelPermission: SCHOOL_ROSTER_ACCESS_PERMISSION,
    },
    {
      id: "INTEGRATIONS",
      label: "integration:integrations",
      children: [
        "SYNC",
        "SYNCV2",
        "TIMETABLE_SYNC",
        "ATTENDANCE_SYNC",
        "ASSESSMENT_SYNC",
        "GRADEBOOK_SYNC",
        "LTI_SETTINGS",
        "OPEN_API_SETUP",
        "INTEGRATION_ANALYTICS",
        "TURNITIN_SETTINGS",
        "INTEGRATIONS_INTERNAL_TOOL",
      ],
      levelId: "L2",
      isSubsection: true,
      accountLevelPermission: INTEGRATIONS_VIEW_AND_MANAGE_PERM,
      programLevelPermission: INTEGRATIONS_PROGRAMME_LEVEL_VIEW_AND_MANAGE_PERM,
      permission: INTEGRATIONS_VIEW_AND_MANAGE_PERM,
      curriculumPrograms: ["IB_PYP", "IB_MYP", "UBD", "IB_DP"],
      skipForTeacher: true,
    },
    {
      id: "INTEGRATIONS_MODULE",
      label: "integration:integrations",
      children: ["INTEGRATIONS_DASHBOARD", "INTEGRATIONS_CATALOG"],
      levelId: "L2",
      route: "integrations",
      perm: "AdminPortal:IntegrationsDashboard",
      curriculumPrograms: ["IB_PYP", "IB_MYP", "UBD", "IB_DP"],
      isSubsection: true,
    },
    {
      id: "EXTERNAL_STAFF",
      label: "schoolSetup:external_users",
      children: ["VISITOR_SETUP", "CAS_EXTERNAL_SUPERVISOR_SETUP"],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: ["IB_PYP", "IB_MYP", "UBD", "IB_DP"],
    },
    {
      id: "TOOLS",
      label: "common:school_setup_tools",
      children: [
        "UNIT_PLAN_PDF_DOWNLOADER",
        "ASSESSMENT_TRANSFER",
        "POST_IMPORT_TOOL",
        "SFTP",
      ],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: ["IB_PYP", "IB_MYP", "UBD", "IB_DP"],
    },
    {
      id: "UBD_ACADEMIC_SETUP",
      label: "teacherHomePage:academic_setup",
      children: [
        "SUBJECTS_SECTION_UBD",
        "UBD_LEARNING_GOALS",
        "GRADING_V2",
        "UBD_GRADING",
        "ACADEMIC_ASSESSMENTS_UBD",
        "ACADEMIC_TEMPLATES_UBD",
      ],
      curriculumPrograms: ["UBD"],
      levelId: "L1",
      route: "ubdAcademicSetup",
      icon: <IconAvatar icon={SetupOutlined} color="teal" />,
      isDynamicNode: true,
      showBreadCrumb: false,
      permission: ACADEMIC_SETUP_VIEW_PERM,
    },
    {
      id: "UBD_GRADING",
      label: "common:grading",
      children: [
        "UBD_GRADING_PERIODS",
        "UBD_GRADING_SETUP",
        "UBD_ASSESSMENT_SETTINGS_EVALUATION_CRITERIA",
        "UBD_GPA_AND_CREDITS",
      ],
      levelId: "L2",
      isSubsection: true,
    },
    {
      id: "UBD_GRADING_PERIODS",
      label: "common:grading_period_plural",
      children: [],
      levelId: "L2",
      route: "grading-periods",
      perm: "AdminPortal:GradingPeriods",
    },
    {
      id: "UBD_GRADING_SETUP",
      label: "academicSetup:grading_setup",
      children: [
        "UBD_OVERALL_SETUP",
        "UBD_OVERALL_SETUP-divider",
        "UBD_ASSESSMENTS_SETUP",
        "UBD_CUMULATIVE_SCORE_SETUP",
        "UBD_OVERALL_GRADE_SETUP",
        "UBD_GRADE_SCALE_SETUP",
        "UBD_ASSESSMENT_TYPES_SETUP_V2",
        "UBD_AGGREGATE_SETUP",
        "UBD_NOMENCLATURE_SETUP-divider",
        "UBD_NOMENCLATURE_SETUP",
      ],
      levelId: "L2",
      route: "grading-setup",
      hasSubTabs: true,
      perm: "AdminPortal:AssessmentSettings",
    },
    {
      id: "UBD_ASSESSMENT_SETTINGS_EVALUATION_CRITERIA",
      label: "academicSetup:evaluation_criteria",
      children: [
        "UBD_CREATE_EVALUATION_CRITERIA",
        "UBD_MAP_EVALUATION_CRITERIA",
        "UBD_EVALUATION_CRITERIA_SETTINGS",
      ],
      levelId: "L2",
      route: "evaluation-criteria-setup",
      hasSubTabs: true,
      perm: "AdminPortal:EvaluationCriteriaV2",
    },
    {
      id: "UBD_OVERALL_SETUP",
      parent: "UBD_GRADING_SETUP",
      label: "academicSetup:overall_score_and_grade_setup",
      levelId: "L3",
      children: [],
      route: "overall-setup",
      perm: "AdminPortal:AssessmentSettings",
    },
    {
      id: "UBD_OVERALL_SETUP-divider",
      parent: "UBD_GRADING_SETUP",
      isDivider: true,
      perm: "AdminPortal:AssessmentSettings",
      levelId: "L3",
    },
    {
      id: "UBD_NOMENCLATURE_SETUP-divider",
      parent: "UBD_GRADING_SETUP",
      isDivider: true,
      perm: "FeatureFlag:EnableNomenclatureForCriteriaSet",
      levelId: "L3",
    },
    {
      id: "UBD_ASSESSMENTS_SETUP",
      parent: "UBD_GRADING_SETUP",
      label: "progressSummary:assessments",
      levelId: "L3",
      children: [],
      route: "assessment-setup",
      perm: "AdminPortal:AssessmentCategoriesV2",
    },
    {
      id: "UBD_CUMULATIVE_SCORE_SETUP",
      parent: "UBD_GRADING_SETUP",
      label: "academicSetup:cumulative_scores",
      levelId: "L3",
      children: [],
      route: "cumulative-score-setup",
      perm: "AdminPortal:ShowCumulativeColumns",
    },
    {
      id: "UBD_OVERALL_GRADE_SETUP",
      parent: "UBD_GRADING_SETUP",
      label: "academicSetup:overall_grade_setup",
      levelId: "L3",
      children: [],
      route: "overall-grade-setup",
      perm: "AdminPortal:UBDLocalGrades",
    },
    {
      id: "UBD_GRADE_SCALE_SETUP",
      parent: "UBD_GRADING_SETUP",
      label: "academicSetup:grade_boundaries",
      levelId: "L3",
      children: [],
      route: "grade-boundary-setup",
      perm: "AdminPortal:LocalGradeSetup",
    },
    {
      id: "UBD_AGGREGATE_SETUP",
      parent: "UBD_GRADING_SETUP",
      label: "academicSetup:score_aggregation",
      levelId: "L3",
      children: [],
      route: "aggregate-setup",
      perm: "FeatureFlag:ScoreAndGradeAggregation",
    },
    {
      id: "UBD_CREATE_EVALUATION_CRITERIA",
      parent: "UBD_ASSESSMENT_SETTINGS_EVALUATION_CRITERIA",
      label: "academicSetup:create_evaluation_criteria",
      levelId: "L3",
      children: [],
      route: "create-evaluation-criteria",
      perm: "AdminPortal:EvaluationCriteriaV2",
    },
    {
      id: "UBD_MAP_EVALUATION_CRITERIA",
      parent: "UBD_ASSESSMENT_SETTINGS_EVALUATION_CRITERIA",
      label: "academicSetup:map_evaluation_criteria",
      levelId: "L3",
      children: [],
      route: "map-evaluation-criteria",
      perm: "AdminPortal:AssessmentCriteriaV2",
    },
    {
      id: "UBD_EVALUATION_CRITERIA_SETTINGS",
      parent: "UBD_ASSESSMENT_SETTINGS_EVALUATION_CRITERIA",
      label: "common:settings",
      levelId: "L3",
      children: [],
      route: "settings",
      perm: "AdminPortal:EvaluationCriteriaSettings",
    },
    {
      id: "PYP_ADMIN_GRADEBOOK",
      children: [],
      label: "common:gradebook",
      curriculumPrograms: [CURRICULUM_TYPE_PYP],
      permission: ADMIN_GRADEBOOK_ACCESS_PERMISSION,
      levelId: "L1",
      route: "gradebook",
      isDynamicNode: true,
      icon: <IconAvatar icon={ClipboardPencilLinesOutlined} color="pink" />,
    },
    {
      id: "MYP_ADMIN_GRADEBOOK",
      children: [],
      label: "common:gradebook",
      curriculumPrograms: [CURRICULUM_TYPE_MYP],
      permission: ADMIN_GRADEBOOK_ACCESS_PERMISSION,
      levelId: "L1",
      route: "gradebook",
      isDynamicNode: true,
      icon: <IconAvatar icon={ClipboardPencilLinesOutlined} color="violet" />,
    },
    {
      id: "UBD_ADMIN_GRADEBOOK",
      children: [],
      label: "common:gradebook",
      curriculumPrograms: [CURRICULUM_TYPE_UBD],
      permission: ADMIN_GRADEBOOK_ACCESS_PERMISSION,
      levelId: "L1",
      route: "gradebook",
      isDynamicNode: true,
      icon: <IconAvatar icon={ClipboardPencilLinesOutlined} color="teal" />,
    },
    {
      id: "DP_ADMIN_GRADEBOOK",
      children: [],
      label: "common:gradebook",
      curriculumPrograms: [CURRICULUM_TYPE_DP],
      permission: ADMIN_GRADEBOOK_ACCESS_PERMISSION,
      levelId: "L1",
      route: "gradebook",
      isDynamicNode: true,
      icon: <IconAvatar icon={ClipboardPencilLinesOutlined} color="yellow" />,
    },
    {
      id: "PYP_ATTENDANCE_DASHBOARD",
      children: [],
      label: "attendance:attendance_manager",
      curriculumPrograms: ["IB_PYP"],
      perm: "Common:AttendanceDashboard",
      permission: ATTENDANCE_DASHBOARD_ACCESS_PERMISSION,
      levelId: "L1",
      route: "attendance-dashboard",
      isDynamicNode: true,
      icon: <IconAvatar icon={AttendanceOutlined} color="pink" />,
      rolesAndPermissionKey: "ATTENDANCE",
      sentralPortalDisablityFeatureFlag:
        SENTRAL_PERMISSION_CONFIGURATIONS.ATTENDANCE,
    },
    {
      id: "MYP_ATTENDANCE_DASHBOARD",
      children: [],
      label: "attendance:attendance_manager",
      curriculumPrograms: ["IB_MYP"],
      perm: "Common:AttendanceDashboard",
      permission: ATTENDANCE_DASHBOARD_ACCESS_PERMISSION,
      levelId: "L1",
      route: "attendance-dashboard",
      isDynamicNode: true,
      icon: <IconAvatar icon={AttendanceOutlined} color="violet" />,
      rolesAndPermissionKey: "ATTENDANCE",
      sentralPortalDisablityFeatureFlag:
        SENTRAL_PERMISSION_CONFIGURATIONS.ATTENDANCE,
    },
    {
      id: "UBD_ATTENDANCE_DASHBOARD",
      children: [],
      label: "attendance:attendance_manager",
      curriculumPrograms: ["UBD"],
      perm: "Common:AttendanceDashboard",
      permission: ATTENDANCE_DASHBOARD_ACCESS_PERMISSION,
      levelId: "L1",
      route: "attendance-dashboard",
      isDynamicNode: true,
      icon: <IconAvatar icon={AttendanceOutlined} color="teal" />,
      rolesAndPermissionKey: "ATTENDANCE",
      sentralPortalDisablityFeatureFlag:
        SENTRAL_PERMISSION_CONFIGURATIONS.ATTENDANCE,
    },
    {
      id: "DP_ATTENDANCE_DASHBOARD",
      children: [],
      label: "attendance:attendance_manager",
      curriculumPrograms: ["IB_DP"],
      perm: "Common:AttendanceDashboard",
      permission: ATTENDANCE_DASHBOARD_ACCESS_PERMISSION,
      levelId: "L1",
      route: "attendance-dashboard",
      isDynamicNode: true,
      icon: <IconAvatar icon={AttendanceOutlined} color="yellow" />,
      rolesAndPermissionKey: "ATTENDANCE",
      sentralPortalDisablityFeatureFlag:
        SENTRAL_PERMISSION_CONFIGURATIONS.ATTENDANCE,
    },
    {
      id: "PYP_TIMETABLE",
      children: [],
      label: "common:timetable",
      curriculumPrograms: ["IB_PYP"],
      perm: "FeatureFlag:AdminTimetable",
      permission: CAN_VIEW_TIMETABLE_CONFIGURATIONS_PERMISSION,
      levelId: "L1",
      route: "timetable",
      isDynamicNode: true,
      icon: <IconAvatar icon={SetupOutlined} color="pink" />,
      rolesAndPermissionKey: "TIMETABLE",
      sentralPortalDisablityFeatureFlag:
        SENTRAL_PERMISSION_CONFIGURATIONS.TIMETABLE,
    },
    {
      id: "MYP_TIMETABLE",
      children: [],
      label: "common:timetable",
      curriculumPrograms: ["IB_MYP"],
      perm: "FeatureFlag:AdminTimetable",
      permission: CAN_VIEW_TIMETABLE_CONFIGURATIONS_PERMISSION,
      levelId: "L1",
      route: "timetable",
      isDynamicNode: true,
      icon: <IconAvatar icon={SetupOutlined} color="violet" />,
      rolesAndPermissionKey: "TIMETABLE",
      sentralPortalDisablityFeatureFlag:
        SENTRAL_PERMISSION_CONFIGURATIONS.TIMETABLE,
    },
    {
      id: "UBD_TIMETABLE",
      children: [],
      label: "common:timetable",
      curriculumPrograms: ["UBD"],
      perm: "FeatureFlag:AdminTimetable",
      permission: CAN_VIEW_TIMETABLE_CONFIGURATIONS_PERMISSION,
      levelId: "L1",
      route: "timetable",
      isDynamicNode: true,
      icon: <IconAvatar icon={SetupOutlined} color="teal" />,
      rolesAndPermissionKey: "TIMETABLE",
      sentralPortalDisablityFeatureFlag:
        SENTRAL_PERMISSION_CONFIGURATIONS.TIMETABLE,
    },
    {
      id: "DP_TIMETABLE",
      children: [],
      label: "common:timetable",
      curriculumPrograms: ["IB_DP"],
      perm: "FeatureFlag:AdminTimetable",
      permission: CAN_VIEW_TIMETABLE_CONFIGURATIONS_PERMISSION,
      levelId: "L1",
      route: "timetable",
      isDynamicNode: true,
      icon: <IconAvatar icon={SetupOutlined} color="yellow" />,
      rolesAndPermissionKey: "TIMETABLE",
      sentralPortalDisablityFeatureFlag:
        SENTRAL_PERMISSION_CONFIGURATIONS.TIMETABLE,
    },
    {
      id: "PYP_ATTENDANCE_AND_TIMETABLE_SETTINGS",
      children: [],
      label: "attendance:timetable_settings",
      curriculumPrograms: ["IB_PYP"],
      perm: "FeatureFlag:Toddle2.0Timetable",
      permission: CAN_VIEW_SCHOOL_TIMETABLE_CONFIGURATIONS_V2_PERMISSION,
      levelId: "L1",
      route: "attendance-and-timetable-settings",
      isDynamicNode: true,
      icon: <IconAvatar icon={SetupOutlined} color="pink" />,
      rolesAndPermissionKey: "TIMETABLE",
      sentralPortalDisablityFeatureFlag:
        SENTRAL_PERMISSION_CONFIGURATIONS.TIMETABLE,
    },
    {
      id: "MYP_ATTENDANCE_AND_TIMETABLE_SETTINGS",
      children: [],
      label: "attendance:timetable_settings",
      curriculumPrograms: ["IB_MYP"],
      perm: "FeatureFlag:Toddle2.0Timetable",
      permission: CAN_VIEW_SCHOOL_TIMETABLE_CONFIGURATIONS_V2_PERMISSION,
      levelId: "L1",
      route: "attendance-and-timetable-settings",
      isDynamicNode: true,
      icon: <IconAvatar icon={SetupOutlined} color="violet" />,
      rolesAndPermissionKey: "TIMETABLE",
      sentralPortalDisablityFeatureFlag:
        SENTRAL_PERMISSION_CONFIGURATIONS.TIMETABLE,
    },
    {
      id: "UBD_ATTENDANCE_AND_TIMETABLE_SETTINGS",
      children: [],
      label: "attendance:timetable_settings",
      curriculumPrograms: ["UBD"],
      perm: "FeatureFlag:Toddle2.0Timetable",
      permission: CAN_VIEW_SCHOOL_TIMETABLE_CONFIGURATIONS_V2_PERMISSION,
      levelId: "L1",
      route: "attendance-and-timetable-settings",
      isDynamicNode: true,
      icon: <IconAvatar icon={SetupOutlined} color="teal" />,
      rolesAndPermissionKey: "TIMETABLE",
      sentralPortalDisablityFeatureFlag:
        SENTRAL_PERMISSION_CONFIGURATIONS.TIMETABLE,
    },
    {
      id: "DP_ATTENDANCE_AND_TIMETABLE_SETTINGS",
      children: [],
      label: "attendance:timetable_settings",
      curriculumPrograms: ["IB_DP"],
      perm: "FeatureFlag:Toddle2.0Timetable",
      permission: CAN_VIEW_SCHOOL_TIMETABLE_CONFIGURATIONS_V2_PERMISSION,
      levelId: "L1",
      route: "attendance-and-timetable-settings",
      isDynamicNode: true,
      icon: <IconAvatar icon={SetupOutlined} color="yellow" />,
      rolesAndPermissionKey: "TIMETABLE",
      sentralPortalDisablityFeatureFlag:
        SENTRAL_PERMISSION_CONFIGURATIONS.TIMETABLE,
    },
    {
      id: "SUBJECTS_SECTION_UBD",
      label: "common:subject_plural",
      children: [
        "UBD_SUBJECTS",
        "UBD_LEARNING_STANDARD",
        "UBD_STANDARDS_V2",
        "DATASETS_V2",
        "UBD_CONTINUUM",
      ],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: ["UBD"],
    },
    {
      id: "UBD_LEARNING_GOALS",
      label: "common:learning_goals",
      children: ["UBD_KEY_CONCEPTS", "UBD_LEARNER_PROFILE", "UBD_ATL"],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: ["UBD"],
    },
    {
      id: "ACADEMIC_ASSESSMENTS_UBD",
      label: "common:assessment_label_plural",
      children: [
        "UBD_ASSESSMENT_SETUP",
        "UBD_SCORE_CATEGORIES_V2",
        "UBD_LOCAL_GRADES",
        "UBD_GRADE_SCALE",
        "UBD_EVALUATION_CRITERIA",
        "UBD_ASSESSMENT_CRITERIA",
        "UBD_SCORE_CATEGORIES",
        "UBD_ASSESSMENT_TYPES_SETUP",
      ],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: ["UBD"],
    },
    {
      id: "UBD_ASSESSMENT_SETUP",
      label: "academicSetup:assessment_setup",
      children: [],
      levelId: "L2",
      route: "assessment-setup",
      perm: "AdminPortal:UBDScoreCategoriesV2",
    },
    {
      id: "UBD_ASSESSMENT_TYPES_SETUP",
      label: "academicSetup:assessment_types",
      children: [],
      levelId: "L3",
      route: "assessment-types",
      perm: "AdminPortal:AssessmentTypesSetup",
    },
    {
      id: "UBD_ASSESSMENT_TYPES_SETUP_V2",
      label: "academicSetup:assessment_types",
      children: [],
      levelId: "L3",
      route: "assessment-types",
      perm: "AdminPortal:AssessmentTypesSetup",
    },
    {
      id: "UBD_NOMENCLATURE_SETUP",
      parent: "UBD_GRADING_SETUP",
      label: "common:nomenclature",
      levelId: "L3",
      children: [],
      route: "nomenclature-setup",
      perm: "FeatureFlag:EnableNomenclatureForCriteriaSet",
    },
    {
      id: "ACADEMIC_TEMPLATES_UBD",
      label: "common:template_plural",
      children: [
        "WORKBOOK_TEMPLATES_PYP_UBD",
        "UBD_ASSESSMENT_TOOL_V2",
        "STUDENT_PROFILE_TEMPLATES",
        "DATA_SETS",
        "FIELDS",
        "MANAGE_TEMPLATES",
        "UBD_ROUTINE_AND_MEAL_TEMPLATES",
      ],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: ["UBD"],
    },
    {
      id: "UBD_EVALUATION_CRITERIA",
      label: "academicSetup:evaluation_criteria",
      children: [],
      levelId: "L3",
      route: "evaluation-criteria",
      perm: "AdminPortal:UBDEvaluationCriteria",
    },
    {
      id: "UBD_LOCAL_GRADES",
      label: "common:local_grades",
      children: [],
      levelId: "L3",
      route: "local-grades",
      perm: "AdminPortal:UBDLocalGrades",
    },
    {
      id: "UBD_GRADE_SCALE",
      label: "academicSetup:overall_grade_setup",
      children: [],
      levelId: "L3",
      route: "overall-grade-setup",
      perm: "AdminPortal:UBDGradeScales",
    },
    {
      id: "UBD_ASSESSMENT_CRITERIA",
      label: "academicSetup:map_evaluation_criteria",
      children: [],
      levelId: "L3",
      route: "assessment-criteria",
      perm: "AdminPortal:UBDAssessmentCriteria",
    },
    {
      id: "MYP_SCORE_CATEGORIES",
      label: "common:point_based_assessment",
      children: [],
      levelId: "L2",
      route: "score-categories",
      perm: "AdminPortal:MYPScoreCategories",
    },
    {
      id: "PYP_SCORE_CATEGORIES",
      label: "common:point_based_assessment",
      children: [],
      levelId: "L2",
      route: "score-categories",
      perm: "AdminPortal:PYPScoreCategories",
    },
    {
      id: "UBD_SCORE_CATEGORIES",
      label: "common:point_based_assessment",
      children: [],
      levelId: "L2",
      route: "score-categories",
      perm: "AdminPortal:UBDScoreCategories",
    },
    {
      id: "UBD_SCORE_CATEGORIES_V2",
      label: "academicSetup:assessment_categories",
      children: [],
      levelId: "L2",
      route: "assessment-categories",
      perm: "AdminPortal:UBDScoreCategoriesV2",
    },
    {
      id: "SCHOOL_INFORMATION",
      label: "common:school_information",
      children: [],
      levelId: "L3",
      route: "school-information",
      perm: "AdminPortal:SchoolInformation",
    },
    {
      id: "OPERATIONAL_DAYS_AND_TIME_ZONE",
      label: "schoolSetup:time_zone_and_operational_days",
      children: [],
      levelId: "L3",
      route: "operational-days-and-time-zone",
      perm: OPERATIONAL_DAYS_AND_TIME_ZONE_PERM,
      skipForTeacher: true,
    },
    {
      id: "ACADEMIC_YEAR_TERMS",
      label: "transcript:academic_years_and_terms",
      children: [],
      levelId: "L3",
      route: "academic-year-terms",
      perm: "AdminPortal:AcademicYearTerms",
      skipForTeacher: true,
    },
    {
      id: "GRADING_PERIODS",
      label: "common:academic_years_and_grading_periods",
      children: [],
      levelId: "L3",
      route: "academic-year-terms",
      perm: "AdminPortal:AcademicYearsAndGradingPeriods",
      skipForTeacher: true,
    },
    {
      id: "YEAR_GROUPS",
      label: "common:year_group_plural",
      children: [],
      levelId: "L3",
      route: "year-groups",
      perm: "FeatureFlag:YearGroupAdminPortalMigration",
      skipForTeacher: true,
    },
    {
      id: "STUDENTS",
      label: "common:student_plural",
      children: [],
      levelId: "L3",
      route: "students",
      perm: "AdminPortal:Students",
      hasSubTabs: true,
      showAllItems: true,
    },
    {
      id: "FAMILY_MEMBERS",
      label: "common:family_member_plural",
      children: [],
      levelId: "L3",
      curriculumPrograms: ["IB_PYP", "IB_MYP", "UBD", "IB_DP"],
      route: "manage-family",
      perm: "AdminPortal:ManageFamilyMembers",
      hasSubTabs: true,
      showAllItems: true,
    },
    {
      id: "TEACHER_SETUP",
      label: "common:staff",
      children: [],
      levelId: "L3",
      route: "teachers",
      perm: "AdminPortal:Teachers",
      hasSubTabs: true,
      showAllItems: true,
    },
    {
      id: "VISITOR_SETUP",
      label: "snp:visitor_plural",
      children: [],
      levelId: "L3",
      route: "visitors",
      permission: VISITORS_VIEW_AND_MANAGE_PERMISSION,
      skipForTeacher: true,
    },
    {
      id: "CAS_EXTERNAL_SUPERVISOR_SETUP",
      label: "project:cas_supervisors",
      children: [],
      levelId: "L3",
      route: "casSupervisors",
      permission: CAS_SUPERVISORS_VIEW_AND_MANAGE_PERMISSION,
      skipForTeacher: true,
    },
    {
      id: "UNIT_PLAN_PDF_DOWNLOADER",
      label: "common:unit_plan_pdf_downloader",
      children: [],
      levelId: "L3",
      route: "unit-planner-download",
      perm: "FeatureFlag:UnitPlannerDownload",
    },
    {
      id: "SFTP",
      label: "common:sftp",
      children: [],
      levelId: "L3",
      route: "sftp",
      perm: "EnableSFTPFileUpload",
    },
    {
      id: "POST_IMPORT_TOOL",
      label: "common:post_import_tool",
      children: [
        "POST_IMPORT_TOOL_BASIC_SETUP",
        "POST_IMPORT_TOOL_ENTITY_MAPPING",
      ],
      levelId: "L3",
      route: "post-import-tool",
      perm: "FeatureFlag:SeesawPostImport",
      hasSubTabs: true,
    },
    {
      id: "POST_IMPORT_TOOL_BASIC_SETUP",
      label: "common:post_import_tool_basic_info",
      children: [],
      levelId: "L4",
      perm: "FeatureFlag:SeesawPostImport",
      parent: "POST_IMPORT_TOOL",
    },
    {
      id: "POST_IMPORT_TOOL_ENTITY_MAPPING",
      label: "common:post_import_tool_entity_mapping",
      children: [],
      levelId: "L4",
      perm: "FeatureFlag:SeesawPostImport",
      parent: "POST_IMPORT_TOOL",
    },
    {
      id: "ASSESSMENT_TRANSFER",
      label: "common:import_assignments_for_tps",
      children: ["BASIC_SETUP", "ENTITY_MAPPING"],
      levelId: "L3",
      route: "assessment-transfer",
      perm: [
        "FeatureFlag:ManageBacAssessmentTransfer",
        "IsEnabledImportGradebook",
      ],
      hasSubTabs: true,
    },
    {
      id: "BASIC_SETUP",
      label: "common:basic_info",
      children: [],
      levelId: "L4",
      perm: [
        "FeatureFlag:ManageBacAssessmentTransfer",
        "IsEnabledImportGradebook",
      ],
      parent: "ASSESSMENT_TRANSFER",
    },
    {
      id: "ENTITY_MAPPING",
      label: "common:entity_mapping",
      children: [],
      levelId: "L4",
      perm: [
        "FeatureFlag:ManageBacAssessmentTransfer",
        "IsEnabledImportGradebook",
      ],
      parent: "ASSESSMENT_TRANSFER",
    },
    {
      id: "LEARNING_COURSE_SETUP",
      label: "course:courses",
      children: [],
      levelId: "L3",
      route: "learning-courses",
      hasSubTabs: true,
      showAllItems: false,
    },
    {
      id: "COURSE_SETUP",
      label: "common:class_plural",
      children: [],
      levelId: "L3",
      route: "classes",
      perm: "AdminPortal:Courses",
      hasSubTabs: true,
      showAllItems: false,
    },
    {
      id: "GRADES_SETUP",
      label: "common:grade_plural",
      children: [],
      levelId: "L3",
      route: "grades",
      perm: "AdminPortal:Grades",
      hasSubTabs: true,
      showAllItems: false,
    },
    {
      id: "LOGIN_CONFIGURATION",
      label: "common:login_configuration",
      children: [],
      levelId: "L3",
      route: "login-configuration",
      perm: [CAN_VIEW_LOGIN_CONFIGURATION, IS_MFA_ENABLED],
      hasSubTabs: true,
      showAllItems: false,
    },
    {
      id: "LOGIN_PAGE_CONFIGURATION",
      label: "common:login_page",
      children: [],
      levelId: "L4",
      parent: "LOGIN_CONFIGURATION",
      route: "page",
      perm: CAN_VIEW_LOGIN_CONFIGURATION,
    },
    {
      id: "LOGIN_OPTIONS_CONFIGURATION",
      label: "common:login_options",
      children: [],
      levelId: "L4",
      parent: "LOGIN_CONFIGURATION",
      route: "options",
      perm: CAN_VIEW_LOGIN_CONFIGURATION,
    },
    {
      id: "MFA_CONFIGURATION",
      label: "common:2fa",
      children: [],
      levelId: "L4",
      parent: "LOGIN_CONFIGURATION",
      route: "mfa",
      perm: IS_MFA_ENABLED,
    },
    {
      id: "ATTENDANCE_SETUP",
      label: "common:attendance",
      children: [],
      levelId: "L2",
      route: "attendance",
      perm: "AdminPortal:AttendanceSetup",
    },
    {
      id: "PERIODS_SETUP",
      label: "scheduler:period_plural",
      children: [],
      levelId: "L3",
      route: "periods",
      perm: "AdminPortal:Periods",
      permission: CAN_VIEW_TIMETABLE_CONFIGURATIONS_PERMISSION,
      hasSubTabs: true,
      showAllItems: false,
    },
    // {
    //   id: "SCHOOL_CALENDAR_V2",
    //   label: "configuration:school_calendar",
    //   children: [],
    //   levelId: "L1",
    //   perm: "AdminPortal:CalendarV2",
    //   route: "school-calendar",
    //   curriculumPrograms: ["IB_PYP", "IB_MYP", "UBD", "IB_DP"],
    //   icon: <Calendar3D />,
    //   iconBgColor: "var(--yellow-900)",
    //   rolesAndPermissionKey: "SCHOOL_CALENDAR",
    // },
    {
      id: "PYP_ACADEMIC_SETUP",
      label: "teacherHomePage:academic_setup",
      children: [
        "SUBJECTS_SECTION",
        "LEARNING_GOALS",
        "GRADING_V2",
        "PYP_GRADING",
        "ACADEMIC_ASSESSMENTS",
        "ACADEMIC_TEMPLATES",
      ],
      curriculumPrograms: ["IB_PYP"],
      levelId: "L1",
      route: "academicSetup",
      icon: <IconAvatar icon={SetupOutlined} color="pink" />,
      isDynamicNode: true,
      showBreadCrumb: false,
      permission: ACADEMIC_SETUP_VIEW_PERM,
    },
    {
      id: "GRADING_V2",
      label: "common:grading",
      children: ["GRADING_SETUP_V2"],
      levelId: "L2",
      isSubsection: true,
      isCommonAcrossCurriculums: true, // Indicating this node is common across curriculums so we will add check for curriculum program when finding parent node
    },
    {
      id: "GRADING_SETUP_V2",
      label: "academicSetup:grading_setup",
      children: [
        "OVERALL_SETUP",
        "SCORE_BASED_GRADING",
        "STANDARD_BASED_GRADING",
        "PROJECTS_SETUP",
        "OTHER_GRADING_SETUP_SETTINGS",
      ],
      levelId: "L2",
      route: "grading",
      hasSubTabs: true,
      perm: GRADING_SETUP_V2_PERM,
    },
    {
      id: "OVERALL_SETUP",
      parent: "GRADING_SETUP_V2",
      label: "academicSetup:overall_setup",
      children: ["GRADING_METHODOLOGY", "GRADE_SCALES", "FINAL_GRADE_SETUP"],
      isSubsectionInsideSubTab: true,
      levelId: "L3",
      isSubsection: true,
      perm: GRADING_SETUP_V2_PERM,
    },
    {
      id: "GRADING_METHODOLOGY",
      parent: "GRADING_SETUP_V2",
      label: "academicSetup:grading_methodology",
      children: [],
      levelId: "L3",
      route: "grading-methodology",
      perm: GRADING_SETUP_V2_PERM,
    },
    {
      id: "GRADE_SCALES",
      parent: "GRADING_SETUP_V2",
      label: "academicSetup:grade_scales",
      children: [],
      levelId: "L3",
      route: "grade-scales",
      perm: GRADING_SETUP_V2_PERM,
    },
    {
      id: "FINAL_GRADE_SETUP",
      parent: "OTHER_GRADING_SETUP_SETTINGS",
      label: "academicSetup:final_grade_setup",
      children: [],
      levelId: "L3",
      route: "final-grade-setup",
      perm: GRADING_SETUP_V2_PERM,
    },
    {
      id: "SCORE_BASED_GRADING",
      parent: "GRADING_SETUP_V2",
      label: "common:score_based_grading",
      isSubsectionInsideSubTab: true,
      children: ["GRADING_CATEGORIES", "SCORE_CALCULATION"],
      levelId: "L3",
      isSubsection: true,
      perm: GRADING_SETUP_V2_PERM,
    },
    {
      id: "SCORE_CALCULATION",
      parent: "GRADING_SETUP_V2",
      label: "common:score_calculation",
      children: [],
      levelId: "L3",
      route: "score-calculation",
      perm: GRADING_SETUP_V2_PERM,
    },
    {
      id: "GRADING_CATEGORIES",
      parent: "GRADING_SETUP_V2",
      label: "classRoom:grading_categories",
      children: [],
      levelId: "L3",
      route: "grading-categories",
      perm: GRADING_SETUP_V2_PERM,
    },
    {
      id: "STANDARD_BASED_GRADING",
      parent: "GRADING_SETUP_V2",
      label: "common:standard_based_grading",
      children: ["GRADE_SCALES_AND_DESCRIPTORS", "STANDARD_CALCULATION"],
      levelId: "L3",
      isSubsectionInsideSubTab: true,
      isSubsection: true,
      perm: GRADING_SETUP_V2_PERM,
    },
    {
      id: "STANDARD_CALCULATION",
      parent: "GRADING_SETUP_V2",
      label: "common:standard_calculation",
      children: [],
      levelId: "L3",
      route: "standard-calculation",
      perm: GRADING_SETUP_V2_PERM,
    },
    {
      id: "GRADE_SCALES_AND_DESCRIPTORS",
      parent: "GRADING_SETUP_V2",
      label: "common:standard_grade_scales_and_descriptors",
      children: [],
      levelId: "L3",
      route: "scales-and-descriptors",
      perm: GRADING_SETUP_V2_PERM,
    },
    {
      id: "PROJECTS_SETUP",
      levelId: "L3",
      parent: "GRADIN_SETUP_V2",
      label: "common:projects_setup",
      isSubsectionInsideSubTab: true,
      isSubsection: true,
      perm: GRADING_SETUP_V2_PERM,
      children: ["OVERALL_PROGRESS_INDICATORS"],
    },

    {
      id: "OVERALL_PROGRESS_INDICATORS",
      label: "project:project_progress_markers",
      children: [],
      levelId: "L3",
      route: "project-progress-indicators",
      parent: "GRADING_SETUP_V2",
      perm: GRADING_SETUP_V2_PERM,
    },
    {
      id: "OTHER_GRADING_SETUP_SETTINGS",
      parent: "GRADING_SETUP_V2",
      label: "common:other_settings",
      children: ["LEARNING_GOALS_GRADING", "VISIBILITY_SETTINGS"],
      levelId: "L3",
      isSubsectionInsideSubTab: true,
      isSubsection: true,
      perm: GRADING_SETUP_V2_PERM,
    },
    {
      id: "LEARNING_GOALS_GRADING",
      parent: "OTHER_GRADING_SETUP_SETTINGS",
      label: "academicSetup:learning_goals_grading",
      children: [],
      levelId: "L3",
      route: "learning-goals-grading",
      perm: LEARNING_GOALS_GRADING_PERM,
    },
    {
      id: "VISIBILITY_SETTINGS",
      parent: "OTHER_GRADING_SETUP_SETTINGS",
      label: "common:visibility_settings",
      children: [],
      levelId: "L3",
      route: "visibility-settings",
      perm: [
        GRADING_VISIBILITY_SETTINGS_PERM,
        GRADING_VISIBILITY_SETTINGS_V2_PERM,
      ],
    },
    {
      id: "PYP_GRADING",
      label: "common:grading",
      children: [
        "PYP_GRADING_PERIODS",
        "PYP_GRADING_SETUP",
        "PYP_ASSESSMENT_SETTINGS_EVALUATION_CRITERIA",
        "PYP_GPA_AND_CREDITS",
      ],
      levelId: "L2",
      isSubsection: true,
    },
    {
      id: "PYP_GRADING_PERIODS",
      label: "common:grading_period_plural",
      children: [],
      levelId: "L2",
      route: "grading-periods",
      perm: "AdminPortal:GradingPeriods",
    },
    {
      id: "PYP_GRADING_SETUP",
      label: "academicSetup:grading_setup",
      children: [
        "PYP_OVERALL_SETUP",
        "PYP_OVERALL_SETUP-divider",
        "PYP_ASSESSMENTS_SETUP",
        "PYP_CUMULATIVE_SCORE_SETUP",
        "PYP_LOCAL_GRADE_SETUP",
        "PYP_AGGREGATE_SETUP",
        "PYP_NOMENCLATURE_SETUP-divider",
        "PYP_NOMENCLATURE_SETUP",
      ],
      levelId: "L2",
      route: "grading-setup",
      hasSubTabs: true,
      perm: "AdminPortal:AssessmentSettings",
    },
    {
      id: "PYP_ASSESSMENT_SETTINGS_EVALUATION_CRITERIA",
      label: "academicSetup:evaluation_criteria",
      children: [
        "PYP_CREATE_EVALUATION_CRITERIA",
        "PYP_MAP_EVALUATION_CRITERIA",
        "PYP_EVALUATION_CRITERIA_SETTINGS",
      ],
      levelId: "L2",
      route: "evaluation-criteria-setup",
      hasSubTabs: true,
      perm: "AdminPortal:EvaluationCriteriaV2",
    },
    {
      id: "PYP_OVERALL_SETUP",
      parent: "PYP_GRADING_SETUP",
      label: "academicSetup:overall_score_setup",
      levelId: "L3",
      children: [],
      route: "overall-setup",
      perm: "AdminPortal:AssessmentSettings",
    },
    {
      id: "PYP_OVERALL_SETUP-divider",
      parent: "PYP_GRADING_SETUP",
      isDivider: true,
      perm: "AdminPortal:AssessmentSettings",
      levelId: "L3",
    },
    {
      id: "PYP_NOMENCLATURE_SETUP-divider",
      parent: "PYP_GRADING_SETUP",
      isDivider: true,
      perm: "FeatureFlag:EnableNomenclatureForCriteriaSet",
      levelId: "L3",
    },
    {
      id: "PYP_ASSESSMENTS_SETUP",
      parent: "PYP_GRADING_SETUP",
      label: "progressSummary:assessments",
      levelId: "L3",
      children: [],
      route: "assessment-setup",
      perm: "AdminPortal:AssessmentCategoriesV2",
    },
    {
      id: "PYP_CUMULATIVE_SCORE_SETUP",
      parent: "PYP_GRADING_SETUP",
      label: "academicSetup:cumulative_scores",
      levelId: "L3",
      children: [],
      route: "cumulative-score-setup",
      perm: "AdminPortal:ShowCumulativeColumns",
    },
    {
      id: "PYP_LOCAL_GRADE_SETUP",
      parent: "PYP_GRADING_SETUP",
      label: "common:local_grades",
      levelId: "L3",
      children: [],
      route: "local-grade-setup",
      perm: "AdminPortal:LocalGradeSetup",
    },
    {
      id: "PYP_NOMENCLATURE_SETUP",
      parent: "PYP_GRADING_SETUP",
      label: "common:nomenclature",
      levelId: "L3",
      children: [],
      route: "nomenclature-setup",
      perm: "FeatureFlag:EnableNomenclatureForCriteriaSet",
    },
    {
      id: "PYP_AGGREGATE_SETUP",
      parent: "PYP_GRADING_SETUP",
      label: "academicSetup:score_aggregation",
      levelId: "L3",
      children: [],
      route: "aggregate-setup",
      perm: "FeatureFlag:ScoreAndGradeAggregation",
    },
    {
      id: "PYP_CREATE_EVALUATION_CRITERIA",
      parent: "PYP_ASSESSMENT_SETTINGS_EVALUATION_CRITERIA",
      label: "academicSetup:create_evaluation_criteria",
      levelId: "L3",
      children: [],
      route: "create-evaluation-criteria",
      perm: "AdminPortal:EvaluationCriteriaV2",
    },
    {
      id: "PYP_MAP_EVALUATION_CRITERIA",
      parent: "PYP_ASSESSMENT_SETTINGS_EVALUATION_CRITERIA",
      label: "academicSetup:map_evaluation_criteria",
      levelId: "L3",
      children: [],
      route: "map-evaluation-criteria",
      perm: "AdminPortal:AssessmentCriteriaV2",
    },
    {
      id: "PYP_EVALUATION_CRITERIA_SETTINGS",
      parent: "PYP_ASSESSMENT_SETTINGS_EVALUATION_CRITERIA",
      label: "common:settings",
      levelId: "L3",
      children: [],
      route: "settings",
      perm: "AdminPortal:EvaluationCriteriaSettings",
    },
    {
      id: "SUBJECTS_SECTION",
      label: "common:subject_plural",
      children: [
        "SUBJECTS",
        "CONCEPTS_RELATED_CONCEPTS",
        "SCOPE_SEQUENCE",
        "PYP_STANDARDS_V2",
        "DATASETS_V2",
        "CONTINUUM",
      ],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: ["IB_PYP"],
    },
    {
      id: "LEARNING_GOALS",
      label: "common:learning_goals",
      children: ["LEARNER_PROFILES", "ATL", "ACTION"],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: ["IB_PYP"],
    },
    {
      id: "ACADEMIC_ASSESSMENTS",
      label: "common:assessment_label_plural",
      children: [
        "EVALUATION_CRITERIA",
        "ASSESSMENT_CRITERIA",
        "PYP_SCORE_CATEGORIES",
      ],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: ["IB_PYP"],
    },
    {
      id: "ACADEMIC_TEMPLATES",
      label: "common:template_plural",
      children: [
        "WORKBOOK_TEMPLATES_PYP_UBD",
        "PYP_ASSESSMENT_TOOL_V2",
        "STUDENT_PROFILE_TEMPLATES",
        "DATA_SETS",
        "FIELDS",
        "MANAGE_TEMPLATES",
        "PYP_ROUTINE_AND_MEAL_TEMPLATES",
      ],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: ["IB_PYP"],
    },
    {
      id: "PYP_SETTINGS",
      label: "common:module_settings",
      children: ["PROGRAM_OTHER_SETTINGS", "GENERAL_SETTINGS"],
      levelId: "L1",
      route: "settings",
      icon: <IconAvatar icon={SettingsOutlined} color="pink" />,
      permission: MODULE_SETTINGS_ACCESS_PERMISSION,
      curriculumPrograms: ["IB_PYP"],
      isDynamicNode: true,
    },
    {
      id: "MYP_SETTINGS",
      label: "common:module_settings",
      children: ["PROGRAM_OTHER_SETTINGS", "GENERAL_SETTINGS"],
      levelId: "L1",
      route: "settings",
      icon: <IconAvatar icon={SettingsOutlined} color="violet" />,
      permission: MODULE_SETTINGS_ACCESS_PERMISSION,
      curriculumPrograms: ["IB_MYP"],
      isDynamicNode: true,
    },
    {
      id: "UBD_SETTINGS",
      label: "common:module_settings",
      children: ["PROGRAM_OTHER_SETTINGS", "GENERAL_SETTINGS"],
      levelId: "L1",
      route: "settings",
      icon: <IconAvatar icon={SettingsOutlined} color="teal" />,
      permission: MODULE_SETTINGS_ACCESS_PERMISSION,
      curriculumPrograms: ["UBD"],
      isDynamicNode: true,
    },
    {
      id: "DP_SETTINGS",
      label: "common:module_settings",
      children: ["PROGRAM_OTHER_SETTINGS", "GENERAL_SETTINGS"],
      levelId: "L1",
      route: "settings",
      icon: <IconAvatar icon={SettingsOutlined} color="yellow" />,
      permission: MODULE_SETTINGS_ACCESS_PERMISSION,
      curriculumPrograms: ["IB_DP"],
      isDynamicNode: true,
    },
    {
      id: "PYP_NOTIFICATIONS_MANAGER",
      label: "configuration:notifications_manager",
      levelId: "L1",
      route: "notificationsmanager",
      icon: <IconAvatar icon={NotificationSettingsOutlined} color="pink" />,
      permission: VIEW_AND_MANAGE_NOTIFICATIONS,
      curriculumPrograms: ["IB_PYP"],
      isDynamicNode: true,
      checkOnlyForParentPermission: true,
    },
    {
      id: "MYP_NOTIFICATIONS_MANAGER",
      label: "configuration:notifications_manager",
      levelId: "L1",
      route: "notificationsmanager",
      icon: <IconAvatar icon={NotificationSettingsOutlined} color="violet" />,
      permission: VIEW_AND_MANAGE_NOTIFICATIONS,
      curriculumPrograms: ["IB_MYP"],
      isDynamicNode: true,
      checkOnlyForParentPermission: true,
    },
    {
      id: "UBD_NOTIFICATIONS_MANAGER",
      label: "configuration:notifications_manager",
      levelId: "L1",
      route: "notificationsmanager",
      icon: <IconAvatar icon={NotificationSettingsOutlined} color="teal" />,
      permission: VIEW_AND_MANAGE_NOTIFICATIONS,
      curriculumPrograms: ["UBD"],
      isDynamicNode: true,
      checkOnlyForParentPermission: true,
    },
    {
      id: "DP_NOTIFICATIONS_MANAGER",
      label: "configuration:notifications_manager",
      levelId: "L1",
      route: "notificationsmanager",
      icon: <IconAvatar icon={NotificationSettingsOutlined} color="yellow" />,
      permission: VIEW_AND_MANAGE_NOTIFICATIONS,
      curriculumPrograms: ["IB_DP"],
      isDynamicNode: true,
      checkOnlyForParentPermission: true,
    },
    {
      id: "GENERAL_SETTINGS",
      label: "common:general_settings",
      levelId: "L2",
      isSubSection: true,
      children: [
        "PROGRAM_MODULE_SETTINGS",
        "ATTENDANCE_SETTINGS",
        "EMAIL_SETTINGS",
        "PORTFOLIO_MANAGER",
        "ANNOUNCEMENTS_MANAGER",
        "PROJECT_SETTING",
        "PROJECT_SETTING_V2",
      ],
    },
    {
      id: "PROGRAM_OTHER_SETTINGS",
      label: "common:other_settings",
      levelId: "L2",
      isSubSection: true,
      children: ["USER_SETTINGS"],
    },
    {
      id: "FIELDS",
      label: "common:custom_field_plural",
      levelId: "L3",
      route: "manage-fields",
      perm: ENABLE_TEMPLATE_FIELDS,
    },
    {
      id: "DATA_SETS",
      label: "common:custom_data_set_plural",
      levelId: "L3",
      route: "manage-data-sets",
      perm: ENABLE_CUSTOM_DATA_SETS,
    },

    {
      id: "SCHOOL_ANALYTICS",
      label: "common:custom_reports",
      levelId: "L1",
      route: "custom-reports",
      icon: <ProgressSummary3D />,
      iconBgColor: "var(--teal-900)",
      perm: ENABLE_SCHOOL_ANALYTICS,
      showBreadCrumb: false,
      skipForTeacher: false,
      skipRolesAndPermissionsCheck: true,
    },
    {
      id: "ACTIVITY_LOGS",
      label: "schoolSetup:activity_log_plural",
      levelId: "L1",
      route: "activity-logs",
      icon: <ProgressSummary3D />,
      iconBgColor: "var(--teal-900)",
      permission: ACTIVITY_LOG_PERMISSION,
      showBreadCrumb: false,
      skipForTeacher: true,
    },
    {
      id: "TRANSCRIPTS",
      label: "common:transcripts",
      levelId: "L1",
      route: "transcripts",
      curriculumPrograms: [
        CURRICULUM_TYPE_MYP,
        CURRICULUM_TYPE_DP,
        CURRICULUM_TYPE_UBD,
      ],
      icon: <Transcripts3D />,
      iconBgColor: "var(--orange-900)",
      permission: TRANSCRIPT_ADMIN_LEVEL_VIEW_PERMISSION,
      skipForTeacher: true,
    },
    {
      id: "INTEGRATION_SETTINGS",
      label: "common:integrations",
      children: [],
      levelId: "L1",
      route: "integration-settings",
      icon: <Integrations3D />,
      iconBgColor: "var(--pink-900)",
      curriculumPrograms: ["IB_PYP", "IB_MYP", "UBD", "IB_DP"],
      skipForTeacher: true,
    },
    {
      id: "PROGRAM_MODULE_SETTINGS",
      label: "configuration:module_on_off",
      children: [],
      levelId: "L3",
      route: "module-settings",
      perm: ENABLE_MODULE_SETTINGS_IN_PROGRAMME_WIDE_CONFIGURATIONS,
    },
    {
      id: "ATTENDANCE_SETTINGS",
      label: "attendance:attendance",
      children: [],
      levelId: "L3",
      route: "attendance-manager",
      perm: "AdminPortal:AttendanceSettings",
      // Redirection issue [need to check later]
      permission: ATTENDANCE_SETTINGS_ACCESS_PERMISSION,
    },
    {
      id: "EMAIL_SETTINGS",
      label: "configuration:weekly_email_summaries",
      children: [],
      levelId: "L3",
      route: "email-settings",
      perm: "AdminPortal:EmailSettings",
    },
    {
      id: "PORTFOLIO_MANAGER",
      label: "common:portfolio",
      children: ["PERMISSION_SETTINGS", "ACTIVITY_SETTINGS", "PORTFOLIO_SETUP"],
      levelId: "L3",
      route: "portfolio-manager",
      hasSubTabs: true,
      showAllItems: false,
      perm: "AdminPortal:PortfolioManager",
    },
    {
      id: "PROJECT_SETTING",
      label: "configuration:core_ia_ea",
      levelId: "L3",
      route: "projects-settings",
      perm: [
        ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION,
        ENABLE_GRADE_WISE_REFLECTION_QUESTIONS,
      ],
      curriculumPrograms: ["IB_MYP", "IB_DP"],
      isPermNegated: true,
      shouldHideForOtherCurriculums: true, // setting this as true means, this node wouldnt be visible in sidebar for other curriculums
    },
    {
      id: "PROJECT_SETTING_V2",
      label: "configuration:core_ia_ea",
      children: ["ROLE_SETUP", "PROJECT_SETUP", "SAA_REFLECTION_QUESTIONS"],
      levelId: "L3",
      route: "projects-settings-v2",
      curriculumPrograms: ["IB_MYP", "IB_DP"],
      hasSubTabs: true,
      showAllItems: false,
      perm: [
        ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION,
        ENABLE_GRADE_WISE_REFLECTION_QUESTIONS,
      ],
      shouldHideForOtherCurriculums: true, // setting this as true means, this node wouldnt be visible in sidebar for other curriculums
    },

    {
      id: "ROLE_SETUP",
      label: "project:project_roles_and_permissions",
      children: [],
      levelId: "L4",
      route: "role-setup",
      parent: "PROJECT_SETTING_V2",
      perm: ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION,
    },
    {
      id: "PROJECT_SETUP",
      label: "common:settings",
      children: [],
      levelId: "L4",
      route: "projects-setup",
      parent: "PROJECT_SETTING_V2",
      perm: [
        ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION,
        ENABLE_GRADE_WISE_REFLECTION_QUESTIONS,
      ],
    },

    {
      id: "SAA_REFLECTION_QUESTIONS",
      label: "project:service_activity_reflection_questions",
      children: [],
      levelId: "L4",
      route: "saa-reflection-questions",
      curriculumPrograms: ["IB_MYP"],
      parent: "PROJECT_SETTING_V2",
      perm: ENABLE_GRADE_WISE_REFLECTION_QUESTIONS,
      shouldHideForOtherCurriculums: true,
    },

    {
      id: "PERMISSION_SETTINGS",
      label: "common:user_settings",
      children: [],
      levelId: "L4",
      route: "portfolio-settings",
      parent: "PORTFOLIO_MANAGER",
      perm: "AdminPortal:PortfolioManager",
    },
    {
      id: "ACTIVITY_SETTINGS",
      label: "configuration:activity_tracking_setup",
      children: [],
      levelId: "L4",
      route: "activity-settings",
      parent: "PORTFOLIO_MANAGER",
      perm: "EnableActivityTracker",
      onLeaveInterceptor: ({ destinationNode, source }) => {
        if (source === "SIDEBAR_BACK") return true;
        return teacherPortfolioLeaveInterceptor({ destinationNode, source });
      },
    },
    {
      id: "REVIEWER_SETUP",
      label: "journal:reviewer_setup",
      children: [],
      levelId: "L4",
      route: "reviewer-setup",
      parent: "PORTFOLIO_MANAGER",
      perm: "EnablePortfolioReviewer",
      suffix: <WarningTooltip />,
      onLeaveInterceptor: ({ destinationNode, source }) => {
        if (source === "SIDEBAR_BACK") return true;
        return reviewerSetupLeaveInterceptor({ destinationNode, source });
      },
    },
    {
      id: "PORTFOLIO_SETUP",
      label: "configuration:portfolio_setup",
      children: [],
      levelId: "L4",
      route: "portfolio-setup",
      parent: "PORTFOLIO_MANAGER",
      perm: "AdminPortal:PortfolioManager",
      onLeaveInterceptor: ({ destinationNode, source }) => {
        if (source === "SIDEBAR_BACK") return true;
        return teacherPortfolioLeaveInterceptor({ destinationNode, source });
      },
    },
    {
      id: "PYP_MEAL_MENU_TEMPLATES",
      label: "journal:meal_templates",
      children: [],
      levelId: "L3",
      route: "meal-menu-templates",
      parent: "PYP_ROUTINE_AND_MEAL_TEMPLATES",
      perm: ENABLE_ROUTINE_TEMPLATES,
    },
    {
      id: "MYP_MEAL_MENU_TEMPLATES",
      label: "journal:meal_templates",
      children: [],
      levelId: "L3",
      route: "meal-menu-templates",
      parent: "MYP_ROUTINE_AND_MEAL_TEMPLATES",
      perm: ENABLE_ROUTINE_TEMPLATES,
    },
    {
      id: "DP_MEAL_MENU_TEMPLATES",
      label: "journal:meal_templates",
      children: [],
      levelId: "L3",
      route: "meal-menu-templates",
      parent: "DP_ROUTINE_AND_MEAL_TEMPLATES",
      perm: ENABLE_ROUTINE_TEMPLATES,
    },
    {
      id: "UBD_MEAL_MENU_TEMPLATES",
      label: "journal:meal_templates",
      children: [],
      levelId: "L3",
      route: "meal-menu-templates",
      parent: "UBD_ROUTINE_AND_MEAL_TEMPLATES",
      perm: ENABLE_ROUTINE_TEMPLATES,
    },
    {
      id: "ANNOUNCEMENTS_MANAGER",
      label: "announcement:announcements",
      children: ["ANNOUNCEMENT_SETTINGS", "ANNOUNCEMENTS_REVIEWER_SETUP"],
      levelId: "L3",
      route: "announcements-manager",
      hasSubTabs: true,
      showAllItems: false,
      perm: ["FeatureFlag:AnnouncementV3", "Common:AnnouncementReviewFlow"],
    },
    {
      id: "ANNOUNCEMENT_SETTINGS",
      label: "common:settings",
      children: [],
      levelId: "L4",
      route: "announcement-settings",
      parent: "ANNOUNCEMENTS_MANAGER",
      perm: "FeatureFlag:AnnouncementV3",
    },
    {
      id: "ANNOUNCEMENTS_REVIEWER_SETUP",
      label: "common:school_announcements_reviewer_setup",
      children: [],
      levelId: "L4",
      route: "reviewer-setup",
      parent: "ANNOUNCEMENTS_MANAGER",
      perm: "Common:AnnouncementReviewFlow",
      suffix: <InvalidConfigWarning />,
    },
    {
      id: "USER_SETTINGS",
      label: "common:user_settings",
      children: [],
      levelId: "L2",
      route: "user-settings",
      perm: "AdminPortal:UserSettings",
    },
    {
      id: "MYP_ACADEMIC_SETUP",
      label: "teacherHomePage:academic_setup",
      children: [
        "SUBJECTS_SECTION_MYP",
        "CONCEPTS_LPA_MYP",
        "GRADING_V2",
        "MYP_GRADING",
        "ACADEMIC_ASSESSMENTS_MYP",
        "ACADEMIC_TEMPLATES_MYP",
      ],
      curriculumPrograms: ["IB_MYP"],
      levelId: "L1",
      route: "mypAcademicSetup",
      icon: <IconAvatar icon={SetupOutlined} color="violet" />,
      isDynamicNode: true,
      showBreadCrumb: false,
      permission: ACADEMIC_SETUP_VIEW_PERM,
    },
    {
      id: "MYP_GRADING",
      label: "common:grading",
      children: [
        "MYP_GRADING_PERIODS",
        "MYP_GRADING_SETUP",
        "MYP_ASSESSMENT_SETTINGS_EVALUATION_CRITERIA",
        "MYP_OVERALL_PROGRESS_INDICATORS",
        "MYP_GPA_AND_CREDITS",
      ],
      levelId: "L2",
      isSubsection: true,
    },
    {
      id: "MYP_OVERALL_PROGRESS_INDICATORS",
      label: "project:project_progress_markers",
      children: [],
      levelId: "L2",
      route: "project-progress-indicators",
      isPermNegated: true,
    },
    {
      id: "MYP_GRADING_PERIODS",
      label: "common:grading_period_plural",
      children: [],
      levelId: "L2",
      route: "grading-periods",
      perm: "AdminPortal:GradingPeriods",
    },
    {
      id: "MYP_GRADING_SETUP",
      label: "academicSetup:grading_setup",
      children: [
        "MYP_OVERALL_SETUP",
        "MYP_OVERALL_SETUP-divider",
        "MYP_ASSESSMENTS_SETUP",
        "MYP_CUMULATIVE_SCORE_SETUP",
        "MYP_GRADE_BOUNDARY_SETUP",
        "MYP_LOCAL_GRADE_SETUP",
        "MYP_AGGREGATE_SETUP",
        "MYP_NOMENCLATURE_SETUP-divider",
        "MYP_NOMENCLATURE_SETUP",
      ],
      levelId: "L2",
      route: "grading-setup",
      hasSubTabs: true,
      perm: "AdminPortal:AssessmentSettings",
    },
    {
      id: "MYP_ASSESSMENT_SETTINGS_EVALUATION_CRITERIA",
      label: "academicSetup:evaluation_criteria",
      children: [
        "MYP_CREATE_EVALUATION_CRITERIA",
        "MYP_MAP_EVALUATION_CRITERIA",
        "MYP_EVALUATION_CRITERIA_SETTINGS",
      ],
      levelId: "L2",
      route: "evaluation-criteria-setup",
      hasSubTabs: true,
      perm: "AdminPortal:EvaluationCriteriaV2",
    },
    {
      id: "MYP_OVERALL_SETUP",
      parent: "MYP_GRADING_SETUP",
      label: "academicSetup:overall_score_and_ibmpyp_grade_setup",
      levelId: "L3",
      children: [],
      route: "overall-setup",
      perm: "AdminPortal:AssessmentSettings",
    },
    {
      id: "MYP_OVERALL_SETUP-divider",
      parent: "MYP_GRADING_SETUP",
      isDivider: true,
      perm: "AdminPortal:AssessmentSettings",
      levelId: "L3",
    },
    {
      id: "MYP_NOMENCLATURE_SETUP-divider",
      parent: "MYP_GRADING_SETUP",
      isDivider: true,
      perm: "FeatureFlag:EnableNomenclatureForCriteriaSet",
      levelId: "L3",
    },
    {
      id: "MYP_ASSESSMENTS_SETUP",
      parent: "MYP_GRADING_SETUP",
      label: "progressSummary:assessments",
      levelId: "L3",
      children: [],
      route: "assessment-setup",
      perm: "AdminPortal:AssessmentCategoriesV2",
    },
    {
      id: "MYP_CUMULATIVE_SCORE_SETUP",
      parent: "MYP_GRADING_SETUP",
      label: "academicSetup:cumulative_scores",
      levelId: "L3",
      children: [],
      route: "cumulative-score-setup",
      perm: "AdminPortal:ShowCumulativeColumns",
    },
    {
      id: "MYP_GRADE_BOUNDARY_SETUP",
      parent: "MYP_GRADING_SETUP",
      label: "academicSetup:ibmyp_grade_boundaries",
      levelId: "L3",
      children: [],
      route: "grade-boundary-setup",
      perm: "AdminPortal:GradeBoundarySetup",
    },
    {
      id: "MYP_LOCAL_GRADE_SETUP",
      parent: "MYP_GRADING_SETUP",
      label: "common:local_grades",
      levelId: "L3",
      children: [],
      route: "local-grade-setup",
      perm: "AdminPortal:LocalGradeSetup",
    },
    {
      id: "MYP_NOMENCLATURE_SETUP",
      parent: "MYP_GRADING_SETUP",
      label: "common:nomenclature",
      levelId: "L3",
      children: [],
      route: "nomenclature-setup",
      perm: "FeatureFlag:EnableNomenclatureForCriteriaSet",
    },
    {
      id: "MYP_AGGREGATE_SETUP",
      parent: "MYP_GRADING_SETUP",
      label: "academicSetup:score_and_grade_aggregation",
      levelId: "L3",
      children: [],
      route: "aggregate-setup",
      perm: "FeatureFlag:ScoreAndGradeAggregation",
    },
    {
      id: "MYP_CREATE_EVALUATION_CRITERIA",
      parent: "MYP_ASSESSMENT_SETTINGS_EVALUATION_CRITERIA",
      label: "academicSetup:create_evaluation_criteria",
      levelId: "L3",
      children: [],
      route: "create-evaluation-criteria",
      perm: "AdminPortal:EvaluationCriteriaV2",
    },
    {
      id: "MYP_MAP_EVALUATION_CRITERIA",
      parent: "MYP_ASSESSMENT_SETTINGS_EVALUATION_CRITERIA",
      label: "academicSetup:map_evaluation_criteria",
      levelId: "L3",
      children: [],
      route: "map-evaluation-criteria",
      perm: "AdminPortal:AssessmentCriteriaV2",
    },
    {
      id: "MYP_EVALUATION_CRITERIA_SETTINGS",
      parent: "MYP_ASSESSMENT_SETTINGS_EVALUATION_CRITERIA",
      label: "common:settings",
      levelId: "L3",
      children: [],
      route: "settings",
      perm: "AdminPortal:EvaluationCriteriaSettings",
    },
    {
      id: "SUBJECTS_SECTION_MYP",
      label: "common:subject_plural",
      children: [
        "SUBJECT_GROUPS_AND_SUBJECTS",
        "MYP_RELATED_CONCEPTS",
        "LEARNING_STANDARDS",
        "MYP_STANDARDS_V2",
        "DATASETS_V2",
        "CONTINUUM_MYP",
      ],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: ["IB_MYP"],
    },
    {
      id: "CONCEPTS_LPA_MYP",
      label: "common:learning_goals",
      children: ["MYP_KEY_CONCEPTS", "MYP_LEARNER_PROFILE", "MYP_ATL"],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: ["IB_MYP"],
    },
    {
      id: "ACADEMIC_ASSESSMENTS_MYP",
      label: "common:assessment_label_plural",
      children: [
        "MYP_LOCAL_GRADES",
        "MYP_EVALUATION_CRITERIA",
        "MYP_ASSESSMENT_CRITERIA",
        "MYP_SCORE_CATEGORIES",
      ],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: ["IB_MYP"],
    },
    {
      id: "ACADEMIC_TEMPLATES_MYP",
      label: "common:template_plural",
      children: [
        "WORKBOOK_TEMPLATES_MYP_DP",
        "MYP_ASSESSMENT_TOOL_V2",
        "STUDENT_PROFILE_TEMPLATES",
        "DATA_SETS",
        "FIELDS",
        "MYP_ROUTINE_AND_MEAL_TEMPLATES",
        "MANAGE_TEMPLATES",
      ],
      levelId: "L2",
      isSubsection: true,
      curriculumPrograms: ["IB_MYP"],
    },
    {
      id: "TURNITIN_SETTINGS",
      label: "configuration:turnitin",
      children: [],
      route: "turnitin",
      levelId: "L3",
      perm: "AdminPortal:TurnitinSettings",
      skipForTeacher: true,
    },
    {
      id: "LTI_SETTINGS",
      label: "integration:lti_apps",
      children: [],
      route: "lti-settings",
      levelId: "L3",
      perm: "AdminPortal:LTIIntegrations",
      skipForTeacher: true,
    },
    {
      id: "OPEN_API_SETUP",
      label: "integration:open_api_setup",
      children: [],
      route: "public-api-settings",
      levelId: "L3",
      perm: "AdminPortal:OpenAPISetup",
    },
    {
      id: "INTEGRATION_ANALYTICS",
      label: "integration:integration_analytics",
      children: [],
      route: "integration-analytics",
      levelId: "L3",
      perm: "AdminPortal:IntegrationAnalytics",
      skipForTeacher: true,
    },
    {
      id: "SUBJECT_GROUPS_AND_SUBJECTS",
      label: "common:subject_groups_and_subjects",
      children: [],
      levelId: "L3",
      route: "subjectGroupsAndSubjects",
      perm: "AdminPortal:MYPSubjects",
    },
    {
      id: "CONTINUUM",
      label: "teacherHomePage:continuum",
      children: [],
      route: "continuum",
      levelId: "L3",
      isPermNegated: true,
    },
    {
      id: "CONTINUUM_MYP",
      label: "teacherHomePage:continuum",
      children: [],
      route: "continuum",
      levelId: "L3",
      isPermNegated: true,
    },
    {
      id: "UBD_CONTINUUM",
      label: "teacherHomePage:continuum",
      children: [],
      route: "continuum",
      levelId: "L3",
      isPermNegated: true,
    },
    {
      id: "DP_CONTINUUM",
      label: "teacherHomePage:continuum",
      children: [],
      route: "continuum",
      levelId: "L3",
      isPermNegated: true,
    },
    {
      id: "LEARNING_STANDARDS",
      label: "common:content_standards",
      children: [],
      levelId: "L3",
      route: "learning-standards",
      dynamicPlannerElementLabelPerm: ENABLE_MYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
      plannerElementType: "MYP_LEARNING_STANDARD",
      perm: "AdminPortal:MYPLearningStandards",
    },
    {
      id: "UBD_LEARNING_STANDARD",
      label: "common:content_standards",
      children: [],
      levelId: "L3",
      plannerElementType: "UBD_LEARNING_STANDARD",
      isDynamicPlannerElementLabel: true,
      route: "ubd-learning-standards",
      perm: "AdminPortal:UBDLearningStandards",
    },
    {
      id: "MYP_LOCAL_GRADES",
      label: "common:local_grades",
      children: [],
      levelId: "L3",
      route: "local-grades",
      perm: "AdminPortal:MYPLocalGrades",
    },
    {
      id: "MYP_EVALUATION_CRITERIA",
      label: "academicSetup:evaluation_criteria",
      children: [],
      levelId: "L3",
      route: "evaluation-criteria",
      perm: "AdminPortal:MYPEvaluationCriteria",
    },
    {
      id: "MYP_ASSESSMENT_CRITERIA",
      label: "academicSetup:map_evaluation_criteria",
      children: [],
      levelId: "L3",
      route: "assessment-criteria",
      perm: "AdminPortal:MYPAssessmentCriteria",
    },
    {
      id: "MYP_KEY_CONCEPTS",
      label: "common:key_concepts",
      dynamicPlannerElementLabelPerm: ENABLE_MYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
      children: [],
      levelId: "L3",
      route: "key-concepts",
      plannerElementType: "MYP_KEY_CONCEPT",
      perm: "AdminPortal:MYP_KeyConcepts",
    },
    {
      id: "MYP_RELATED_CONCEPTS",
      label: "common:related_concepts",
      dynamicPlannerElementLabelPerm: ENABLE_MYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
      children: [],
      levelId: "L3",
      route: "related-concepts",
      plannerElementType: "MYP_RELATED_CONCEPT",
      perm: "AdminPortal:MYP_RelatedConcepts",
    },
    {
      id: "MYP_LEARNER_PROFILE",
      label: "common:learner_profile_attributes",
      children: [],
      levelId: "L3",
      dynamicPlannerElementLabelPerm: ENABLE_MYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
      plannerElementType: "MYP_LEARNER_PROFILE",
      route: "learner-profile-attributes",
      perm: "AdminPortal:MYP_LearnerProfile",
    },
    {
      id: "UBD_LEARNER_PROFILE",
      label: "common:learner_profile_attributes",
      children: [],
      levelId: "L3",
      plannerElementType: "UBD_LEARNER_PROFILE",
      isDynamicPlannerElementLabel: true,
      route: "learner-profile-attributes",
      perm: "AdminPortal:UBDLearnerProfile",
    },
    {
      id: "SUBJECTS",
      label: "common:subject_plural",
      children: [],
      levelId: "L3",
      route: "subjects",
      perm: "AdminPortal:Subjects",
    },
    {
      id: "UBD_SUBJECTS",
      label: "common:subject_plural",
      children: [],
      levelId: "L3",
      route: "subjects",
      perm: "AdminPortal:UBD_Subjects",
    },
    {
      id: "UBD_KEY_CONCEPTS",
      label: "common:key_concepts",
      children: [],
      levelId: "L3",
      plannerElementType: "UBD_KEY_CONCEPT",
      isDynamicPlannerElementLabel: true,
      route: "key-concepts",
      perm: "AdminPortal:UBDKeyConcepts",
    },
    {
      id: "CONCEPTS_RELATED_CONCEPTS",
      label: "teacherHomePage:concepts_related_concepts",
      children: [],
      levelId: "L3",
      route: "concepts",
      perm: "AdminPortal:Concepts",
    },
    {
      id: "LEARNER_PROFILES",
      label: "common:lp_label",
      children: [],
      levelId: "L3",
      route: "learnerProfiles",
      perm: "AdminPortal:LearnerProfile",
      dynamicPlannerElementLabelPerm: ENABLE_PYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
      plannerElementType: ELEMENT_TYPE_PYP_LEARNER_PROFILE,
    },
    {
      id: "ACTION",
      label: "common:action",
      children: [],
      levelId: "L3",
      route: "action",
      perm: ENABLE_ACTION_SET_EDITING,
    },
    {
      id: "PYP_STANDARDS_V2",
      label: "common:standard_plural",
      children: [],
      levelId: "L3",
      route: "standards",
      perm: "AdminPortal:StandardsV2",
      plannerElementType: ELEMENT_TYPE_PYP_LEARNING_STANDARD,
      isDynamicPlannerElementLabel: true,
    },
    {
      id: "MYP_STANDARDS_V2",
      label: "common:standard_plural",
      children: [],
      levelId: "L3",
      route: "standards",
      perm: "AdminPortal:StandardsV2",
      plannerElementType: "MYP_LEARNING_STANDARD",
      isDynamicPlannerElementLabel: true,
    },
    {
      id: "UBD_STANDARDS_V2",
      children: [],
      levelId: "L3",
      route: "standards",
      perm: "AdminPortal:StandardsV2",
      plannerElementType: "UBD_LEARNING_STANDARD",
      isDynamicPlannerElementLabel: true,
    },
    {
      id: "DP_STANDARDS_V2",
      label: "common:standard_plural",
      children: [],
      levelId: "L3",
      isDynamicPlannerElementLabel: true,
      plannerElementType: "DP_SUBJECT_STANDARD",
      route: "standards",
      perm: "AdminPortal:StandardsV2",
    },
    {
      id: "DATASETS_V2",
      label: "common:learning_goals",
      children: [],
      levelId: "L3",
      route: "datasets",
      perm: "AdminPortal:DatasetsV2",
    },
    {
      id: "SCOPE_SEQUENCE",
      label: "common:content_standards",
      children: [],
      levelId: "L3",
      route: "scopeandsequence",
      perm: "AdminPortal:ScopeAndSequance",
      dynamicPlannerElementLabelPerm: ENABLE_PYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
      plannerElementType: ELEMENT_TYPE_PYP_LEARNING_STANDARD,
    },
    {
      id: "ATL",
      label: "common:atls_label",
      children: [],
      levelId: "L3",
      route: "atl",
      perm: "AdminPortal:ATL",
      dynamicPlannerElementLabelPerm: ENABLE_PYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
      plannerElementType: ELEMENT_TYPE_PYP_ATL,
    },
    {
      id: "UBD_ATL",
      label: "common:skill_plural",
      plannerElementType: "UBD_ATL",
      isDynamicPlannerElementLabel: true,
      children: [],
      levelId: "L3",
      route: "atl",
      perm: "AdminPortal:UBD_Atls",
    },
    {
      id: "MYP_ATL",
      label: "common:approaches_to_learning",
      plannerElementType: "MYP_ATL",
      dynamicPlannerElementLabelPerm: ENABLE_MYP_DYNAMIC_PLANNER_ELEMENT_LABEL,
      children: [],
      levelId: "L3",
      route: "atl",
      perm: "AdminPortal:MYP_Atls",
    },
    {
      id: "DP_ATL",
      label: "common:approaches_to_learning",
      plannerElementType: "DP_ATL",
      children: [],
      levelId: "L3",
      route: "atl",
      perm: "AdminPortal:DP_Atls",
    },
    {
      id: "EVALUATION_CRITERIA",
      label: "academicSetup:evaluation_criteria",
      children: [],
      levelId: "L3",
      route: "evaluation-criteria",
      perm: "AdminPortal:EvaluationCriteria",
    },
    {
      id: "ASSESSMENT_CRITERIA",
      label: "academicSetup:map_evaluation_criteria",
      children: [],
      levelId: "L3",
      route: "assessment-criteria",
      perm: "AdminPortal:AssessmentCriteria",
    },
    {
      id: "PYP_ROUTINE_AND_MEAL_TEMPLATES",
      label: "journal:routines_meal_plans_and_food_codes",
      children: ["PYP_ROUTINE_TEMPLATES", "PYP_MEAL_MENU_TEMPLATES"],
      levelId: "L2",
      route: "routineAndMealTemplates",
      hasSubTabs: true,
      perm: ENABLE_ROUTINE_TEMPLATES,
    },
    {
      id: "MYP_ROUTINE_AND_MEAL_TEMPLATES",
      label: "journal:routines_meal_plans_and_food_codes",
      children: ["MYP_ROUTINE_TEMPLATES", "MYP_MEAL_MENU_TEMPLATES"],
      levelId: "L2",
      route: "routineAndMealTemplates",
      hasSubTabs: true,
      perm: ENABLE_ROUTINE_TEMPLATES,
    },
    {
      id: "DP_ROUTINE_AND_MEAL_TEMPLATES",
      label: "journal:routines_meal_plans_and_food_codes",
      children: ["DP_ROUTINE_TEMPLATES", "DP_MEAL_MENU_TEMPLATES"],
      levelId: "L2",
      route: "routineAndMealTemplates",
      hasSubTabs: true,
      perm: ENABLE_ROUTINE_TEMPLATES,
    },
    {
      id: "UBD_ROUTINE_AND_MEAL_TEMPLATES",
      label: "journal:routines_meal_plans_and_food_codes",
      children: ["UBD_ROUTINE_TEMPLATES", "UBD_MEAL_MENU_TEMPLATES"],
      levelId: "L2",
      route: "routineAndMealTemplates",
      hasSubTabs: true,
      perm: ENABLE_ROUTINE_TEMPLATES,
    },
    {
      id: "PYP_ASSESSMENT_TOOL_V2",
      label: "teacherHomePage:assessment_tool",
      children: [
        "PYP_RUBRIC_SETUP",
        "PYP_CHECKLIST_SETUP",
        "PYP_SINGLE_POINT_RUBRIC_SETUP",
        "PYP_SCORE_BASED_RUBRIC_SETUP",
        "PYP_STANDARD_BASED_RUBRIC_SETUP",
      ],
      levelId: "L2",
      route: "assessmentTool",
      hasSubTabs: true,
      perm: "AdminPortal:AssessmentToolV2",
    },
    {
      id: "MYP_ASSESSMENT_TOOL_V2",
      label: "teacherHomePage:assessment_tool",
      children: [
        "MYP_RUBRIC_SETUP",
        "MYP_CHECKLIST_SETUP",
        "MYP_SINGLE_POINT_RUBRIC_SETUP",
        "MYP_SCORE_BASED_RUBRIC_SETUP",
        "MYP_STANDARD_BASED_RUBRIC_SETUP",
      ],
      levelId: "L2",
      route: "assessmentTool",
      hasSubTabs: true,
      perm: "AdminPortal:AssessmentToolV2",
    },
    {
      id: "DP_ASSESSMENT_TOOL_V2",
      label: "teacherHomePage:assessment_tool",
      children: [
        "DP_RUBRIC_SETUP",
        "DP_CHECKLIST_SETUP",
        "DP_SINGLE_POINT_RUBRIC_SETUP",
        "DP_SCORE_BASED_RUBRIC_SETUP",
        "DP_STANDARD_BASED_RUBRIC_SETUP",
      ],
      levelId: "L2",
      route: "assessmentTool",
      hasSubTabs: true,
      perm: "AdminPortal:AssessmentToolV2",
    },
    {
      id: "UBD_ASSESSMENT_TOOL_V2",
      label: "teacherHomePage:assessment_tool",
      children: [
        "UBD_RUBRIC_SETUP",
        "UBD_CHECKLIST_SETUP",
        "UBD_SINGLE_POINT_RUBRIC_SETUP",
        "UBD_SCORE_BASED_RUBRIC_SETUP",
        "UBD_STANDARD_BASED_RUBRIC_SETUP",
      ],
      levelId: "L2",
      route: "assessmentTool",
      hasSubTabs: true,
      perm: "AdminPortal:AssessmentToolV2",
    },
    {
      id: "PROGRESS_REPORT_TEMPLATE",
      label: "progressReport:report_templates_label",
      children: [],
      levelId: "L2",
      route: "progressreporttemplate",
      permission: PROGRESS_REPORTS_ADMIN_LEVEL_VIEW_PERMISSION,
    },
    {
      id: "MANAGE_TEMPLATES",
      label: "common:template_plural",
      children: [],
      levelId: "L3",
      route: "manage-templates",
      perm: "FeatureFlag:EnablePlannerTemplates",
    },
    {
      id: "PYP_ROUTINE_TEMPLATES",
      label: "journal:routine_templates",
      levelId: "L3",
      children: [],
      route: "routine-templates",
      parent: "PYP_ROUTINE_AND_MEAL_TEMPLATES",
      perm: ENABLE_ROUTINE_TEMPLATES,
    },
    {
      id: "MYP_ROUTINE_TEMPLATES",
      label: "journal:routine_templates",
      levelId: "L3",
      children: [],
      route: "routine-templates",
      parent: "MYP_ROUTINE_AND_MEAL_TEMPLATES",
      perm: ENABLE_ROUTINE_TEMPLATES,
    },
    {
      id: "DP_ROUTINE_TEMPLATES",
      label: "journal:routine_templates",
      levelId: "L3",
      children: [],
      route: "routine-templates",
      parent: "DP_ROUTINE_AND_MEAL_TEMPLATES",
      perm: ENABLE_ROUTINE_TEMPLATES,
    },
    {
      id: "UBD_ROUTINE_TEMPLATES",
      label: "journal:routine_templates",
      levelId: "L3",
      children: [],
      route: "routine-templates",
      parent: "UBD_ROUTINE_AND_MEAL_TEMPLATES",
      perm: ENABLE_ROUTINE_TEMPLATES,
    },
    {
      id: "WORKBOOK_TEMPLATES_PYP_UBD",
      label: "teacherHomePage:workbook_templates",
      children: [],
      levelId: "L3",
      route: "workbook-templates",
      isPermNegated: true,
    },
    {
      id: "WORKBOOK_TEMPLATES_MYP_DP",
      label: "teacherHomePage:workbook_templates",
      children: [],
      levelId: "L3",
      route: "workbook-templates",
      isPermNegated: true,
    },
    {
      id: "STUDENT_PROFILE_TEMPLATES",
      label: "teacherHomePage:student_profile_template",
      children: [],
      levelId: "L3",
      route: "studentprofiletemplate",
      perm: "AdminPortal:StudentProfileTemplates",
    },
    {
      id: "SYNC",
      label: "integration:sync",
      children: [],
      levelId: "L3",
      route: "sync",
      perm: "AdminPortal:ShowSyncLink",
      skipForTeacher: true,
    },
    {
      id: "SYNCV2",
      label: "integration:roster_sync",
      children: [],
      levelId: "L3",
      route: "manage-sync",
      perm: "AdminPortal:ShowSyncLinkV2",
      skipForTeacher: true,
    },
    {
      id: "INTEGRATIONS_DASHBOARD",
      label: "common:dashboard",
      children: [],
      levelId: "L3",
      route: "dashboard",
      parent: "INTEGRATIONS_MODULE",
      perm: "AdminPortal:IntegrationsDashboard",
      prefixParentNodeRoute: true,
    },
    {
      id: "INTEGRATIONS_CATALOG",
      label: "integration:catalog",
      children: [],
      levelId: "L3",
      route: "catalog",
      parent: "INTEGRATIONS_MODULE",
      perm: "AdminPortal:IntegrationsCatalog",
      prefixParentNodeRoute: true,
    },
    {
      id: "USER_NAME_SETTINGS",
      label: "common:user_name_settings",
      children: [],
      levelId: "L3",
      route: "name-settings",
      perm: "AdminPortal:UserNameSetting",
    },
    {
      id: "TIMETABLE_SYNC",
      label: "integration:timetable_sync",
      children: [],
      levelId: "L3",
      route: "timetable-sync",
      perm: "FeatureFlag:EnableTimetableSyncV2",
      skipForTeacher: true,
    },
    {
      id: "ATTENDANCE_SYNC",
      label: "integration:attendance_sync",
      children: [],
      levelId: "L3",
      route: "attendance-sync",
      perm: "FeatureFlag:EnableAttendanceSyncV2",
      skipForTeacher: true,
    },
    {
      id: "ASSESSMENT_SYNC",
      label: "integration:assignment_sync",
      children: [],
      levelId: "L3",
      route: "assessment-sync",
      perm: "AdminPortal:AssessmentSync",
      skipForTeacher: true,
    },
    {
      id: "GRADEBOOK_SYNC",
      label: "integration:final_grade_sync",
      children: [],
      levelId: "L3",
      route: "gradebook-sync",
      perm: "AdminPortal:GradebookSync",
      skipForTeacher: true,
    },
    {
      id: "INTEGRATIONS_INTERNAL_TOOL",
      label: "common:school_setup_tools",
      children: [],
      levelId: "L3",
      route: "internal-tools",
      perm: "FeatureFlag:ShowIntegrationsInternalTool",
      skipForTeacher: true,
    },
    {
      id: "DOWNLOAD",
      label: "integration:support_download_sheet",
      children: [],
      levelId: "L3",
      route: "download-sheet",
      perm: "AdminPortal:DownloadSheet",
      skipForTeacher: true,
    },
    {
      id: "ACADEMY_ANALYTICS",
      label: "common:academy_analytics",
      children: [],
      icon: <Goals3D />,
      iconBgColor: "var(--blue-900)",
      levelId: "L1",
      route: "academy-analytics",
      perm: "FeatureFlag:WorkrampAcademyAnalytics",
      permission: ACADEMY_ANALYTICS_ACCESS_PERMISSION,
      skipForTeacher: true,
    },
    {
      id: "SCHOOL_SETTINGS_MODULE",
      label: "common:settings",
      children: [
        "USER_NAME_SETTINGS_V2",
        "SCHOOL_MODULE_SETTINGS",
        "STUDENT_ALERT_SETTINGS",
      ],

      icon: <Settings3D />,
      iconBgColor: "var(--blue-900)",
      levelId: "L1",
      route: "school-settings",
      permission: SCHOOL_WIDE_SETTINGS_ACCESS_PERMISSION,
    },
    {
      id: "ATTENDANCE_CATEGORIES",
      label: "configuration:attendance_categories",
      children: [],
      levelId: "L2",
      parent: "SCHOOL_SETTINGS_MODULE",
      route: "attendance-categories",
      perm: "FeatureFlag:MultiCurriculumAttendanceCategories",
    },
    {
      id: "USER_NAME_SETTINGS_V2",
      label: "common:user_name_settings",
      children: [],
      levelId: "L2",
      parent: "SCHOOL_SETTINGS_MODULE",
      route: "user-name-settings",
      perm: "AdminPortal:UserNameSettingV2",
      skipForTeacher: true,
    },
    {
      id: "SCHOOL_MODULE_SETTINGS",
      label: "common:module_settings",
      children: [],
      route: "module-settings",
      parent: "SCHOOL_SETTINGS_MODULE",
      levelId: "L2",
      perm: "AdminPortal:ModuleSettings",
    },
    {
      id: "STUDENT_ALERT_SETTINGS",
      label: "common:student_alert_settings",
      children: [],
      levelId: "L2",
      route: "student-alert-settings",
      parent: "SCHOOL_SETTINGS_MODULE",
      permission: CAN_VIEW_STUDENT_ALERT_SETTINGS,
    },
    {
      id: "PYP_RUBRIC_SETUP",
      label: "common:rubric_plural",
      parent: "PYP_ASSESSMENT_TOOL_V2",
      children: [],
      levelId: "L3",
      route: "rubric",
      perm: "AdminPortal:AssessmentToolV2",
    },
    {
      id: "MYP_RUBRIC_SETUP",
      label: "common:rubric_plural",
      parent: "MYP_ASSESSMENT_TOOL_V2",
      children: [],
      levelId: "L3",
      route: "rubric",
      perm: "AdminPortal:AssessmentToolV2",
    },
    {
      id: "DP_RUBRIC_SETUP",
      label: "common:rubric_plural",
      parent: "DP_ASSESSMENT_TOOL_V2",
      children: [],
      levelId: "L3",
      route: "rubric",
      perm: "AdminPortal:AssessmentToolV2",
    },
    {
      id: "UBD_RUBRIC_SETUP",
      label: "common:rubric_plural",
      parent: "UBD_ASSESSMENT_TOOL_V2",
      children: [],
      levelId: "L3",
      route: "rubric",
      perm: "AdminPortal:AssessmentToolV2",
    },
    {
      id: "PYP_CHECKLIST_SETUP",
      label: "common:checklist_plural",
      parent: "PYP_ASSESSMENT_TOOL_V2",
      children: [],
      levelId: "L3",
      route: "checklist",
      perm: "AdminPortal:AssessmentToolV2",
    },
    {
      id: "MYP_CHECKLIST_SETUP",
      label: "common:checklist_plural",
      parent: "MYP_ASSESSMENT_TOOL_V2",
      children: [],
      levelId: "L3",
      route: "checklist",
      perm: "AdminPortal:AssessmentToolV2",
    },
    {
      id: "DP_CHECKLIST_SETUP",
      label: "common:checklist_plural",
      parent: "DP_ASSESSMENT_TOOL_V2",
      children: [],
      levelId: "L3",
      route: "checklist",
      perm: "AdminPortal:AssessmentToolV2",
    },
    {
      id: "UBD_CHECKLIST_SETUP",
      label: "common:checklist_plural",
      parent: "UBD_ASSESSMENT_TOOL_V2",
      children: [],
      levelId: "L3",
      route: "checklist",
      perm: "AdminPortal:AssessmentToolV2",
    },
    {
      id: "PYP_SINGLE_POINT_RUBRIC_SETUP",
      label: "common:single_point_rubric_plural_v2",
      parent: "PYP_ASSESSMENT_TOOL_V2",
      children: [],
      levelId: "L3",
      route: "single-point-rubric",
      perm: "AdminPortal:AssessmentToolV2",
    },
    {
      id: "PYP_SCORE_BASED_RUBRIC_SETUP",
      label: "common:score_based_rubrics",
      parent: "PYP_ASSESSMENT_TOOL_V2",
      children: [],
      levelId: "L3",
      route: "score-based-rubric",
      perm: "FeatureFlag:ScoreBasedRubric",
    },
    {
      id: "PYP_STANDARD_BASED_RUBRIC_SETUP",
      label: "common:standard_based_rubrics",
      parent: "PYP_ASSESSMENT_TOOL_V2",
      children: [],
      levelId: "L3",
      route: "standard-based-rubric",
      perm: GRADING_SETUP_V2_PERM,
    },
    {
      id: "MYP_SINGLE_POINT_RUBRIC_SETUP",
      label: "common:single_point_rubric_plural_v2",
      parent: "MYP_ASSESSMENT_TOOL_V2",
      children: [],
      levelId: "L3",
      route: "single-point-rubric",
      perm: "AdminPortal:AssessmentToolV2",
    },
    {
      id: "MYP_SCORE_BASED_RUBRIC_SETUP",
      label: "common:score_based_rubrics",
      parent: "MYP_ASSESSMENT_TOOL_V2",
      children: [],
      levelId: "L3",
      route: "score-based-rubric",
      perm: "FeatureFlag:ScoreBasedRubric",
    },
    {
      id: "MYP_STANDARD_BASED_RUBRIC_SETUP",
      label: "common:standard_based_rubrics",
      parent: "MYP_ASSESSMENT_TOOL_V2",
      children: [],
      levelId: "L3",
      route: "standard-based-rubric",
      perm: GRADING_SETUP_V2_PERM,
    },
    {
      id: "DP_SINGLE_POINT_RUBRIC_SETUP",
      label: "common:single_point_rubric_plural_v2",
      parent: "DP_ASSESSMENT_TOOL_V2",
      children: [],
      levelId: "L3",
      route: "single-point-rubric",
      perm: "AdminPortal:AssessmentToolV2",
    },
    {
      id: "DP_SCORE_BASED_RUBRIC_SETUP",
      label: "common:score_based_rubrics",
      parent: "DP_ASSESSMENT_TOOL_V2",
      children: [],
      levelId: "L3",
      route: "score-based-rubric",
      perm: "FeatureFlag:ScoreBasedRubric",
    },
    {
      id: "DP_STANDARD_BASED_RUBRIC_SETUP",
      label: "common:standard_based_rubrics",
      parent: "DP_ASSESSMENT_TOOL_V2",
      children: [],
      levelId: "L3",
      route: "standard-based-rubric",
      perm: GRADING_SETUP_V2_PERM,
    },
    {
      id: "UBD_SINGLE_POINT_RUBRIC_SETUP",
      label: "common:single_point_rubric_plural_v2",
      parent: "UBD_ASSESSMENT_TOOL_V2",
      children: [],
      levelId: "L3",
      route: "single-point-rubric",
      perm: "AdminPortal:AssessmentToolV2",
    },
    {
      id: "UBD_SCORE_BASED_RUBRIC_SETUP",
      label: "common:score_based_rubrics",
      parent: "UBD_ASSESSMENT_TOOL_V2",
      children: [],
      levelId: "L3",
      route: "score-based-rubric",
      perm: "FeatureFlag:ScoreBasedRubric",
    },
    {
      id: "UBD_STANDARD_BASED_RUBRIC_SETUP",
      label: "common:standard_based_rubrics",
      parent: "UBD_ASSESSMENT_TOOL_V2",
      children: [],
      levelId: "L3",
      route: "standard-based-rubric",
      perm: GRADING_SETUP_V2_PERM,
    },
    {
      id: "PYP_GPA_AND_CREDITS",
      label: "academicSetup:gpa_and_credits",
      children: ["PYP_GPA_SETUP", "PYP_CREDITS_SETUP"],
      levelId: "L2",
      route: "gpa-and-credits",
      hasSubTabs: true,
      perm: "FeatureFlag:EnableGpaAndCredits",
    },
    {
      id: "UBD_GPA_AND_CREDITS",
      label: "academicSetup:gpa_and_credits",
      children: ["UBD_GPA_SETUP", "UBD_CREDITS_SETUP"],
      levelId: "L2",
      route: "gpa-and-credits",
      hasSubTabs: true,
      perm: "FeatureFlag:EnableGpaAndCredits",
    },
    {
      id: "MYP_GPA_AND_CREDITS",
      label: "academicSetup:gpa_and_credits",
      children: ["MYP_GPA_SETUP", "MYP_CREDITS_SETUP"],
      levelId: "L2",
      route: "gpa-and-credits",
      hasSubTabs: true,
      perm: "FeatureFlag:EnableGpaAndCredits",
    },
    {
      id: "DP_GPA_AND_CREDITS",
      label: "academicSetup:gpa_and_credits",
      children: ["DP_GPA_SETUP", "DP_CREDITS_SETUP"],
      levelId: "L2",
      route: "gpa-and-credits",
      hasSubTabs: true,
      perm: "FeatureFlag:EnableGpaAndCredits",
    },
    {
      id: "PYP_GPA_SETUP",
      parent: "PYP_GPA_AND_CREDITS",
      label: "common:gpa",
      levelId: "L3",
      children: [],
      route: "gpa-setup",
      perm: "FeatureFlag:EnableGpaAndCredits",
    },
    {
      id: "UBD_GPA_SETUP",
      parent: "UBD_GPA_AND_CREDITS",
      label: "common:gpa",
      levelId: "L3",
      children: [],
      route: "gpa-setup",
      perm: "FeatureFlag:EnableGpaAndCredits",
    },
    {
      id: "MYP_GPA_SETUP",
      parent: "MYP_GPA_AND_CREDITS",
      label: "common:gpa",
      levelId: "L3",
      children: [],
      route: "gpa-setup",
      perm: "FeatureFlag:EnableGpaAndCredits",
    },
    {
      id: "DP_GPA_SETUP",
      parent: "DP_GPA_AND_CREDITS",
      label: "common:gpa",
      levelId: "L3",
      children: [],
      route: "gpa-setup",
      perm: "FeatureFlag:EnableGpaAndCredits",
    },
    {
      id: "PYP_CREDITS_SETUP",
      parent: "PYP_GPA_AND_CREDITS",
      label: "common:credits",
      levelId: "L3",
      children: [],
      route: "credits-setup",
      perm: "FeatureFlag:EnableGpaAndCredits",
    },
    {
      id: "UBD_CREDITS_SETUP",
      parent: "UBD_GPA_AND_CREDITS",
      label: "common:credits",
      levelId: "L3",
      children: [],
      route: "credits-setup",
      perm: "FeatureFlag:EnableGpaAndCredits",
    },
    {
      id: "MYP_CREDITS_SETUP",
      parent: "MYP_GPA_AND_CREDITS",
      label: "common:credits",
      levelId: "L3",
      children: [],
      route: "credits-setup",
      perm: "FeatureFlag:EnableGpaAndCredits",
    },
    {
      id: "DP_CREDITS_SETUP",
      parent: "DP_GPA_AND_CREDITS",
      label: "common:credits",
      levelId: "L3",
      children: [],
      route: "credits-setup",
      perm: "FeatureFlag:EnableGpaAndCredits",
    },
    {
      id: "PYP_ESF_SENTRAL_WELLBEING",
      label: "common:wellbeing",
      subLabel: "common:powered_by_sentral",
      levelId: "L1",
      curriculumPrograms: [CURRICULUM_TYPE_PYP],
      icon: <IconAvatar icon={UserReflectionOutlined} color="pink" />,
      isDynamicNode: true,
      perm: SENTRAL_PERMISSION_CONFIGURATIONS.WELLBEING,
      onCardClick: (dispatch, curriculumProgramId) => {
        dispatch(
          authorizeUserWithEsfSentral({
            feature: "ESF_SENTRAL_WELLBEING",
            curriculumProgramId,
          })
        );
      },
    },
    {
      id: "MYP_ESF_SENTRAL_WELLBEING",
      label: "common:wellbeing",
      subLabel: "common:powered_by_sentral",
      levelId: "L1",
      curriculumPrograms: [CURRICULUM_TYPE_MYP],
      icon: <IconAvatar icon={UserReflectionOutlined} color="violet" />,
      isDynamicNode: true,
      perm: SENTRAL_PERMISSION_CONFIGURATIONS.WELLBEING,
      onCardClick: (dispatch, curriculumProgramId) => {
        dispatch(
          authorizeUserWithEsfSentral({
            feature: "ESF_SENTRAL_WELLBEING",
            curriculumProgramId,
          })
        );
      },
    },
    {
      id: "DP_ESF_SENTRAL_WELLBEING",
      label: "common:wellbeing",
      subLabel: "common:powered_by_sentral",
      levelId: "L1",
      curriculumPrograms: [CURRICULUM_TYPE_DP],
      icon: <IconAvatar icon={UserReflectionOutlined} color="yellow" />,
      isDynamicNode: true,
      perm: SENTRAL_PERMISSION_CONFIGURATIONS.WELLBEING,
      onCardClick: (dispatch, curriculumProgramId) => {
        dispatch(
          authorizeUserWithEsfSentral({
            feature: "ESF_SENTRAL_WELLBEING",
            curriculumProgramId,
          })
        );
      },
    },
    {
      id: "UBD_ESF_SENTRAL_WELLBEING",
      label: "common:wellbeing",
      subLabel: "common:powered_by_sentral",
      levelId: "L1",
      curriculumPrograms: [CURRICULUM_TYPE_UBD],
      icon: <IconAvatar icon={UserReflectionOutlined} color="teal" />,
      isDynamicNode: true,
      perm: SENTRAL_PERMISSION_CONFIGURATIONS.WELLBEING,
      onCardClick: (dispatch, curriculumProgramId) => {
        dispatch(
          authorizeUserWithEsfSentral({
            feature: "ESF_SENTRAL_WELLBEING",
            curriculumProgramId,
          })
        );
      },
    },
    {
      id: "PYP_ESF_SENTRAL_TIMETABLE",
      label: "common:timetable",
      subLabel: "common:powered_by_sentral",
      levelId: "L1",
      curriculumPrograms: [CURRICULUM_TYPE_PYP],
      icon: <IconAvatar icon={SetupOutlined} color="pink" />,
      isDynamicNode: true,
      perm: SENTRAL_PERMISSION_CONFIGURATIONS.TIMETABLE,
      onCardClick: (dispatch, curriculumProgramId) => {
        dispatch(
          authorizeUserWithEsfSentral({
            feature: "ESF_SENTRAL_TIMETABLE",
            curriculumProgramId,
          })
        );
      },
    },
    {
      id: "MYP_ESF_SENTRAL_TIMETABLE",
      label: "common:timetable",
      subLabel: "common:powered_by_sentral",
      levelId: "L1",
      curriculumPrograms: [CURRICULUM_TYPE_MYP],
      icon: <IconAvatar icon={SetupOutlined} color="violet" />,
      isDynamicNode: true,
      perm: SENTRAL_PERMISSION_CONFIGURATIONS.TIMETABLE,
      onCardClick: (dispatch, curriculumProgramId) => {
        dispatch(
          authorizeUserWithEsfSentral({
            feature: "ESF_SENTRAL_TIMETABLE",
            curriculumProgramId,
          })
        );
      },
    },
    {
      id: "DP_ESF_SENTRAL_TIMETABLE",
      label: "common:timetable",
      subLabel: "common:powered_by_sentral",
      levelId: "L1",
      curriculumPrograms: [CURRICULUM_TYPE_DP],
      icon: <IconAvatar icon={SetupOutlined} color="yellow" />,
      isDynamicNode: true,
      perm: SENTRAL_PERMISSION_CONFIGURATIONS.TIMETABLE,
      onCardClick: (dispatch, curriculumProgramId) => {
        dispatch(
          authorizeUserWithEsfSentral({
            feature: "ESF_SENTRAL_TIMETABLE",
            curriculumProgramId,
          })
        );
      },
    },
    {
      id: "UBD_ESF_SENTRAL_TIMETABLE",
      label: "common:timetable",
      subLabel: "common:powered_by_sentral",
      levelId: "L1",
      curriculumPrograms: [CURRICULUM_TYPE_UBD],
      icon: <IconAvatar icon={SetupOutlined} color="teal" />,
      isDynamicNode: true,
      perm: SENTRAL_PERMISSION_CONFIGURATIONS.TIMETABLE,
      onCardClick: (dispatch, curriculumProgramId) => {
        dispatch(
          authorizeUserWithEsfSentral({
            feature: "ESF_SENTRAL_TIMETABLE",
            curriculumProgramId,
          })
        );
      },
    },
    {
      id: "PYP_ESF_SENTRAL_ATTENDANCE",
      label: "common:attendance",
      subLabel: "common:powered_by_sentral",
      levelId: "L1",
      curriculumPrograms: [CURRICULUM_TYPE_PYP],
      icon: <IconAvatar icon={AttendanceOutlined} color="pink" />,
      isDynamicNode: true,
      perm: SENTRAL_PERMISSION_CONFIGURATIONS.ATTENDANCE,
      onCardClick: (dispatch, curriculumProgramId) => {
        dispatch(
          authorizeUserWithEsfSentral({
            feature: "ESF_SENTRAL_ATTENDANCE",
            curriculumProgramId,
          })
        );
      },
    },
    {
      id: "MYP_ESF_SENTRAL_ATTENDANCE",
      label: "common:attendance",
      subLabel: "common:powered_by_sentral",
      levelId: "L1",
      curriculumPrograms: [CURRICULUM_TYPE_MYP],
      icon: <IconAvatar icon={AttendanceOutlined} color="violet" />,
      isDynamicNode: true,
      perm: SENTRAL_PERMISSION_CONFIGURATIONS.ATTENDANCE,
      onCardClick: (dispatch, curriculumProgramId) => {
        dispatch(
          authorizeUserWithEsfSentral({
            feature: "ESF_SENTRAL_ATTENDANCE",
            curriculumProgramId,
          })
        );
      },
    },
    {
      id: "DP_ESF_SENTRAL_ATTENDANCE",
      label: "common:attendance",
      subLabel: "common:powered_by_sentral",
      levelId: "L1",
      curriculumPrograms: [CURRICULUM_TYPE_DP],
      icon: <IconAvatar icon={AttendanceOutlined} color="yellow" />,
      isDynamicNode: true,
      perm: SENTRAL_PERMISSION_CONFIGURATIONS.ATTENDANCE,
      onCardClick: (dispatch, curriculumProgramId) => {
        dispatch(
          authorizeUserWithEsfSentral({
            feature: "ESF_SENTRAL_ATTENDANCE",
            curriculumProgramId,
          })
        );
      },
    },
    {
      id: "UBD_ESF_SENTRAL_ATTENDANCE",
      label: "common:attendance",
      subLabel: "common:powered_by_sentral",
      levelId: "L1",
      curriculumPrograms: [CURRICULUM_TYPE_UBD],
      icon: <IconAvatar icon={AttendanceOutlined} color="teal" />,
      isDynamicNode: true,
      perm: SENTRAL_PERMISSION_CONFIGURATIONS.ATTENDANCE,
      onCardClick: (dispatch, curriculumProgramId) => {
        dispatch(
          authorizeUserWithEsfSentral({
            feature: "ESF_SENTRAL_ATTENDANCE",
            curriculumProgramId,
          })
        );
      },
    },
    {
      id: "PYP_ESF_SENTRAL_POLICIES",
      label: "common:policies_and_resources",
      subLabel: "common:powered_by_sentral",
      levelId: "L1",
      curriculumPrograms: [CURRICULUM_TYPE_PYP],
      icon: <IconAvatar icon={OpenBookTextOutlined} color={"pink"} />,
      isDynamicNode: true,
      perm: SENTRAL_PERMISSION_CONFIGURATIONS.POLICIES_AND_RESOURCES,
      onCardClick: (dispatch, curriculumProgramId) => {
        dispatch(
          authorizeUserWithEsfSentral({
            feature: "ESF_SENTRAL_POLICIES",
            curriculumProgramId,
          })
        );
      },
    },
    {
      id: "MYP_ESF_SENTRAL_POLICIES",
      label: "common:policies_and_resources",
      subLabel: "common:powered_by_sentral",
      levelId: "L1",
      curriculumPrograms: [CURRICULUM_TYPE_MYP],
      icon: <IconAvatar icon={OpenBookTextOutlined} color={"violet"} />,
      isDynamicNode: true,
      perm: SENTRAL_PERMISSION_CONFIGURATIONS.POLICIES_AND_RESOURCES,
      onCardClick: (dispatch, curriculumProgramId) => {
        dispatch(
          authorizeUserWithEsfSentral({
            feature: "ESF_SENTRAL_POLICIES",
            curriculumProgramId,
          })
        );
      },
    },
    {
      id: "DP_ESF_SENTRAL_POLICIES",
      label: "common:policies_and_resources",
      subLabel: "common:powered_by_sentral",
      levelId: "L1",
      curriculumPrograms: [CURRICULUM_TYPE_DP],
      icon: <IconAvatar icon={OpenBookTextOutlined} color={"yellow"} />,
      isDynamicNode: true,
      perm: SENTRAL_PERMISSION_CONFIGURATIONS.POLICIES_AND_RESOURCES,
      onCardClick: (dispatch, curriculumProgramId) => {
        dispatch(
          authorizeUserWithEsfSentral({
            feature: "ESF_SENTRAL_POLICIES",
            curriculumProgramId,
          })
        );
      },
    },
    {
      id: "UBD_ESF_SENTRAL_POLICIES",
      label: "common:policies_and_resources",
      subLabel: "common:powered_by_sentral",
      levelId: "L1",
      curriculumPrograms: [CURRICULUM_TYPE_UBD],
      icon: <IconAvatar icon={OpenBookTextOutlined} color={"teal"} />,
      isDynamicNode: true,
      perm: SENTRAL_PERMISSION_CONFIGURATIONS.POLICIES_AND_RESOURCES,
      onCardClick: (dispatch, curriculumProgramId) => {
        dispatch(
          authorizeUserWithEsfSentral({
            feature: "ESF_SENTRAL_POLICIES",
            curriculumProgramId,
          })
        );
      },
    },
  ],
};

const getCurriculumProgramMenuNodes = ({
  dynamicNodes,
  curriculumPrograms,
}) => {
  const nodes = [];
  const childrenNodes = [];

  // generate menu for all the available curriculum's
  _.forEach(curriculumPrograms, curriculumProgram => {
    const {
      type: curriculumProgramType,
      id: curriculumProgramId,
    } = curriculumProgram;

    const curriculumProgramNodes = [];

    const matchedCurriculumNode = _.find(dynamicNodes, {
      id: curriculumProgramType,
    });

    _.forEach(matchedCurriculumNode?.children, childId => {
      const matchedNode = _.find(dynamicNodes, { id: childId });

      const uid = getAdminMenuUid({
        curriculumProgramId,
        nodeId: childId,
        isDynamicNode: true,
      });

      const route = `${curriculumProgramId}/${matchedNode?.route}`;

      const childNode = {
        ...matchedNode,
        uid,
        route,
      };

      curriculumProgramNodes.push(childNode);
    });

    const updatedLabel = getCurriculumProgramLabel({
      curriculumProgram,
      shouldIncludeAcronym: true,
    });

    const uid = getAdminMenuUid({
      curriculumProgramId,
      nodeId: curriculumProgramType,
      isDynamicNode: true,
    });

    const childrenUids = _.map(curriculumProgramNodes, node => {
      return node.uid;
    });

    const newCurriculumNode = {
      ...matchedCurriculumNode,
      curriculumProgramId,
      label: updatedLabel,
      uid,
      children: childrenUids,
    };

    childrenNodes.push(...curriculumProgramNodes);
    nodes.push(newCurriculumNode);
  });

  return {
    nodes,
    childrenNodes,
  };
};

export const parentOfSchoolConfigurations = {
  LEARNING_COURSE_SETUP: "SCHOOL_SETUP",
  COURSE_SETUP: "SCHOOL_SETUP",
  PERIODS_SETUP: "SCHOOL_SETUP",
  GRADES_SETUP: "SCHOOL_SETUP",
  STUDENTS: "SCHOOL_SETUP",
  TEACHER_SETUP: "SCHOOL_SETUP",
  FAMILY_MEMBERS: "SCHOOL_SETUP",
  ASSESSMENT_TRANSFER: "SCHOOL_SETUP",
  UNIT_PLAN_PDF_DOWNLOADER: "SCHOOL_SETUP",
  SFTP: "SCHOOL_SETUP",
  POST_IMPORT_TOOL: "SCHOOL_SETUP",
  TEACHER_PERMISSIONS: "STAFF_PERMISSIONS",
  SCHOOL_MODULE_SETTINGS: "CURRICULUM_SETTINGS",
};

const getSchoolConfigurationsMenuNodes = ({
  staticNodes,
  curriculumPrograms,
  curriculumConfigMap,
}) => {
  const schoolConfigurationsNodes = [];

  _.forEach(staticNodes, node => {
    const newNode = _.cloneDeep(node);
    const { id, perm, label, showAllItems, children } = newNode;

    switch (id) {
      case "SCHOOL_SETTINGS":
      case "CLASS_ROSTER":
      case "INTEGRATIONS": {
        // add teacher role condition
        if (ACLStore.isStaffPermissionEnabled()) {
          const isAdmin = getIsAdminByRole();

          const filterNodesByStaffRole = _.filter(children, childId => {
            const childNode = _.find(staticNodes, { id: childId });
            return childNode && (isAdmin || !childNode.skipForTeacher);
          });

          newNode["children"] = filterNodesByStaffRole;
        }
        break;
      }
      case "PORTFOLIO_MANAGER": {
        newNode["children"] = [
          "PORTFOLIO_SETUP",
          "ACTIVITY_SETTINGS",
          "PERMISSION_SETTINGS",
          "REVIEWER_SETUP",
        ];
        break;
      }
      case "LOGIN_CONFIGURATION": {
        let node = [];
        if (ACLStore.can(CAN_VIEW_LOGIN_CONFIGURATION)) {
          node = ["LOGIN_PAGE_CONFIGURATION", "LOGIN_OPTIONS_CONFIGURATION"];
        }
        if (ACLStore.can(IS_MFA_ENABLED)) {
          node.push("MFA_CONFIGURATION");
        }
        newNode["children"] = node;
        break;
      }
      case "COURSE_SETUP":
      case "TEACHER_SETUP":
      case "STUDENTS":
      case "GRADES_SETUP":
      case ATTENDANCE_CONSTANTS.PERIODS_SETUP:
      case "FAMILY_MEMBERS":
      case "TEACHER_PERMISSIONS":
        {
          const customProps =
            id === "TEACHER_PERMISSIONS"
              ? {
                  levelId: "L3",
                  prefixParentNodeRoute: true,
                }
              : {};
          const defaultLocaleKeyLabel =
            id === "TEACHER_PERMISSIONS" ? "common:teacher_plural" : label;

          const defaultValue = {
            children: [],
            levelId: "L4",
            parent: id,
            perm,
            ...customProps,
          };

          // generating sub-menu nodes for sidebar
          const subMenuNodes = [];

          _.forEach(curriculumPrograms, curriculumProgram => {
            const {
              id: curriculumProgramId,
              type: curriculumProgramType,
              acronym,
            } = curriculumProgram;
            const curriculumTypeWithoutPrefix = removeIBPrefixFromCurriculumType(
              curriculumProgramType
            );
            const nodeId = `${curriculumTypeWithoutPrefix}_${id}`;

            const uid = getAdminMenuUid({
              curriculumProgramId,
              nodeId,
              isDynamicNode: true,
            });

            const locale_keys = {
              item: defaultLocaleKeyLabel,
              curriculum: acronym ?? `common:${curriculumProgramType}`,
            };

            let curriculumAccessModule = {};
            const configObject = _.get(curriculumConfigMap, [
              curriculumProgramId,
              perm,
            ]);
            let addNodeToList = _.isEmpty(configObject)
              ? ACLStore.can(perm, "one", true)
              : parseConfigurationValue(configObject);

            // check whether the user has admin access to any module of this particular curriculum, if the staff permission module is enabled for the org
            if (ACLStore.isStaffPermissionEnabled() && addNodeToList) {
              const isAdmin = getIsAdminByRole();
              if (!isAdmin) {
                curriculumAccessModule = getSchoolConfigurationAccessModule(
                  curriculumProgramId
                );

                const nodeParent = parentOfSchoolConfigurations[id];
                const nodeValueForCurriculum = _.get(
                  curriculumAccessModule,
                  nodeParent
                );

                const showCurriculumTab =
                  nodeValueForCurriculum &&
                  _.some(nodeValueForCurriculum, value => !!value);

                if (!showCurriculumTab) {
                  addNodeToList = false;
                }
              }
            }

            if (addNodeToList) {
              schoolConfigurationsNodes.push({
                ...defaultValue,
                id: nodeId,
                uid,
                label: "common:admin_curriculum_items",
                locale_keys,
                route: curriculumProgramId,
              });

              subMenuNodes.push(uid);
            }
          });

          const showAllTab =
            (ACLStore.isStaffPermissionEnabled() && !getIsAdminByRole()) ||
            !_.isEqual(curriculumPrograms.length, subMenuNodes.length)
              ? false
              : true;

          if (showAllItems && showAllTab) {
            const nodeId = `ALL_${id}`;
            subMenuNodes.unshift(nodeId);
            schoolConfigurationsNodes.push({
              ...defaultValue,
              uid: nodeId,
              label: "common:all_with_lowercase_label",
              locale_keys: {
                label: label,
              },
              id: nodeId,
            });
          }

          newNode["children"] = subMenuNodes;
        }
        break;
      case "ACADEMY_ANALYTICS":
        {
          const subMenuNodes = [];
          _.forEach(curriculumPrograms, curriculumProgram => {
            const {
              id: curriculumProgramId,
              type: curriculumProgramType,
              acronym,
              variant = null,
            } = curriculumProgram;

            const curriculumTypeWithoutPrefix = removeIBPrefixFromCurriculumType(
              curriculumProgramType
            );
            const nodeId = `${curriculumTypeWithoutPrefix}_${id}`;
            const uid = getAdminMenuUid({
              curriculumProgramId,
              nodeId,
              isDynamicNode: true,
            });

            if (variant !== CURRICULUM_VARIANT_TODDLE_PLAY) {
              schoolConfigurationsNodes.push({
                children: [],
                levelId: "L2",
                parent: id,
                perm,
                id: nodeId,
                uid,
                label: acronym,
                route: curriculumProgramId,
              });
              subMenuNodes.push(uid);
            }
          });
          newNode["children"] = subMenuNodes;
        }
        break;
      case "EXTERNAL_STAFF": {
        let newChildren = newNode.children;

        //show casExternalSupervisorNode only if org has IB_DP

        if (!_.some(curriculumPrograms, { type: "IB_DP" })) {
          newChildren = _.without(newChildren, "CAS_EXTERNAL_SUPERVISOR_SETUP");
        }

        // add teacher role condition
        if (ACLStore.isStaffPermissionEnabled()) {
          const isAdmin = getIsAdminByRole();

          newChildren = _.filter(newChildren, childId => {
            const childNode = _.find(staticNodes, { id: childId });
            return childNode && (isAdmin || !childNode.skipForTeacher);
          });

          newNode["children"] = newChildren;
        }

        newNode["children"] = newChildren;
        break;
      }
      case "SCHOOL_SETTINGS_MODULE": {
        const isAdmin = getIsAdminByRole();
        if (ACLStore.isStaffPermissionEnabled()) {
          const filterNodesByStaffRole = _.filter(children, childId => {
            const childNode = _.find(staticNodes, { id: childId });
            if (childId === "SCHOOL_MODULE_SETTINGS") {
              const curriculumAccessModule = getConfigurationAccess({
                curriculumIds: _.map(curriculumPrograms, "id"),
                moduleKey: "CURRICULUM_SETTINGS",
              });
              return childNode && (isAdmin || curriculumAccessModule);
            }
            return childNode && (isAdmin || !childNode.skipForTeacher);
          });

          newNode["children"] = filterNodesByStaffRole;
          break;
        }
      }
    }
    schoolConfigurationsNodes.push({ ...newNode, uid: newNode.id });
  });

  return schoolConfigurationsNodes;
};

const getSchoolConfigurationsMenuNodesWrtRnP = ({
  staticNodes,
  curriculumPrograms,
  curriculumConfigMap,
}) => {
  const schoolConfigurationsNodes = [];

  _.forEach(staticNodes, node => {
    const newNode = _.cloneDeep(node);
    const { id, perm, label, showAllItems, permission } = newNode;

    switch (id) {
      case "SCHOOL_SETTINGS":
        if (!ACLStore.can(CAN_VIEW_LOGIN_CONFIGURATION)) {
          newNode["children"] = _.without(
            newNode.children,
            "LOGIN_CONFIGURATION"
          );
        }
        break;
      case "PORTFOLIO_MANAGER": {
        newNode["children"] = [
          "PORTFOLIO_SETUP",
          "ACTIVITY_SETTINGS",
          "PERMISSION_SETTINGS",
          "REVIEWER_SETUP",
        ];
        break;
      }
      case "LOGIN_CONFIGURATION": {
        let node = [];
        if (ACLStore.can(CAN_VIEW_LOGIN_CONFIGURATION)) {
          node = ["LOGIN_PAGE_CONFIGURATION", "LOGIN_OPTIONS_CONFIGURATION"];
        }
        if (ACLStore.can(IS_MFA_ENABLED)) {
          node.push("MFA_CONFIGURATION");
        }
        newNode["children"] = node;
        break;
      }
      case "LEARNING_COURSE_SETUP":
      case "COURSE_SETUP":
      case "TEACHER_SETUP":
      case "STUDENTS":
      case "GRADES_SETUP":
      case ATTENDANCE_CONSTANTS.PERIODS_SETUP:
      case "FAMILY_MEMBERS":
      case "TEACHER_PERMISSIONS":
        {
          const customProps =
            id === "TEACHER_PERMISSIONS"
              ? {
                  levelId: "L3",
                  prefixParentNodeRoute: true,
                }
              : {};
          const defaultLocaleKeyLabel =
            id === "TEACHER_PERMISSIONS" ? "common:teacher_plural" : label;

          const defaultValue = {
            children: [],
            levelId: "L4",
            parent: id,
            perm,
            ...customProps,
          };

          // generating sub-menu nodes for sidebar
          const subMenuNodes = [];

          _.forEach(curriculumPrograms, curriculumProgram => {
            const {
              id: curriculumProgramId,
              type: curriculumProgramType,
              acronym,
            } = curriculumProgram;
            const curriculumTypeWithoutPrefix = removeIBPrefixFromCurriculumType(
              curriculumProgramType
            );
            const nodeId = `${curriculumTypeWithoutPrefix}_${id}`;

            const uid = getAdminMenuUid({
              curriculumProgramId,
              nodeId,
              isDynamicNode: true,
            });

            const locale_keys = {
              item: defaultLocaleKeyLabel,
              curriculum: acronym ?? `common:${curriculumProgramType}`,
            };

            const configObject = _.get(curriculumConfigMap, [
              curriculumProgramId,
              perm,
            ]);

            const addNodeToList = _.isEmpty(configObject)
              ? ACLStore.can(perm, "one", true)
              : parseConfigurationValue(configObject);

            let isVisible = true;

            if (id === "LEARNING_COURSE_SETUP") {
              isVisible = getIsLearningCoursesEnabled({ curriculumProgramId });
            }

            if (
              addNodeToList ||
              (id === "LEARNING_COURSE_SETUP" && isVisible)
            ) {
              schoolConfigurationsNodes.push({
                ...defaultValue,
                id: nodeId,
                uid,
                label: "common:admin_curriculum_items",
                locale_keys,
                route: curriculumProgramId,
              });

              subMenuNodes.push(uid);
            }
          });

          const showAllTab = !_.isEqual(
            curriculumPrograms.length,
            subMenuNodes.length
          )
            ? false
            : true;

          if (showAllItems && showAllTab) {
            const nodeId = `ALL_${id}`;
            subMenuNodes.unshift(nodeId);
            schoolConfigurationsNodes.push({
              ...defaultValue,
              uid: nodeId,
              label: "common:all_with_lowercase_label",
              locale_keys: {
                label: label,
              },
              id: nodeId,
            });
          }

          newNode["children"] = subMenuNodes;
        }
        break;

      case "ACADEMY_ANALYTICS":
        {
          const subMenuNodes = [];
          _.forEach(curriculumPrograms, curriculumProgram => {
            const {
              id: curriculumProgramId,
              type: curriculumProgramType,
              acronym,
              variant = null,
            } = curriculumProgram;

            const curriculumTypeWithoutPrefix = removeIBPrefixFromCurriculumType(
              curriculumProgramType
            );
            const nodeId = `${curriculumTypeWithoutPrefix}_${id}`;
            const uid = getAdminMenuUid({
              curriculumProgramId,
              nodeId,
              isDynamicNode: true,
            });

            if (variant !== CURRICULUM_VARIANT_TODDLE_PLAY) {
              schoolConfigurationsNodes.push({
                children: [],
                levelId: "L2",
                parent: id,
                perm,
                permission,
                id: nodeId,
                uid,
                label: acronym,
                route: curriculumProgramId,
              });
              subMenuNodes.push(uid);
            }
          });
          newNode["children"] = subMenuNodes;
        }
        break;
      case "EXTERNAL_STAFF":
        {
          let newChildren = newNode.children;

          //show casExternalSupervisorNode only if org has IB_DP

          if (!_.some(curriculumPrograms, { type: "IB_DP" })) {
            newChildren = _.without(
              newChildren,
              "CAS_EXTERNAL_SUPERVISOR_SETUP"
            );
          }
          newNode["children"] = newChildren;
        }
        break;

      case "SCHOOL_MODULE_SETTINGS":
        {
          newNode["label"] = "configuration:module_on_off";
        }
        break;
    }

    schoolConfigurationsNodes.push({ ...newNode, uid: newNode.id });
  });

  return schoolConfigurationsNodes;
};

const getUpdatedNodes = ({ nodes }) => {
  const isEducatorCenterRevampEnabled = isEducatorCenterRevampParentPermEnabled();

  return _.reduce(
    nodes,
    (updatedNodes, node) => {
      const { id, dynamicPlannerElementLabelPerm } = node;

      // remove old educator center node if educator center revamp is enabled, and new one if not enabled
      if (
        (isEducatorCenterRevampEnabled && id.match(/_EDUCATOR_CENTER$/)) ||
        (!isEducatorCenterRevampEnabled && id.match(/_EDUCATOR_CENTER_V2$/))
      ) {
        return updatedNodes;
      }

      // Add isDynamicPlannerElementLabel if permission exists
      if (dynamicPlannerElementLabelPerm) {
        updatedNodes.push({
          ...node,
          isDynamicPlannerElementLabel: ACLStore.can(
            dynamicPlannerElementLabelPerm
          ),
        });
      } else {
        updatedNodes.push(node);
      }

      return updatedNodes;
    },
    []
  );
};

const isNodeOfStaffPermissionModule = node => {
  const { id, parent } = node;
  return (
    _.includes(["SCHOOL_ADMIN_PERMISSION"], id) ||
    _.includes(["TEACHER_PERMISSIONS"], parent)
  );
};

const adminMenuNodeEnhancer = ({ nodes }) => {
  return _.map(nodes, node => {
    // enhancing staff permissions module's side bar nodes with onLeaveInterceptor
    if (isNodeOfStaffPermissionModule(node)) {
      return {
        ...node,
        onLeaveInterceptor: getStaffPermissionSideBarNodeOnLeaveInterceptor({
          node,
        }),
      };
    }

    const nodeId = _.get(node, "id", "");
    if (_.isEqual(nodeId, MODULES.STAFF_PERMISSIONS.id)) {
      const isAdmin = getIsAdminByRole();
      if (!isAdmin) {
        return {
          ...node,
          children: _.without(node.children, "ADMIN_PERMISSIONS"),
        };
      }
    }
    return node;
  });
};

export const parseMenuItems = ({ curriculumPrograms, curriculumConfigMap }) => {
  const adminMenuNodes = _.cloneDeep(AdminMenu);

  const nodes = getUpdatedNodes({ nodes: adminMenuNodes.nodes });

  const [dynamicNodes, staticNodes] = _.partition(
    nodes,
    node => node.isDynamicNode
  );

  const newAdminMenuRootNodes = [];
  const newAdminMenuNodes = [];

  _.forEach(adminMenuNodes.rootNodes, node => {
    const newRootNode = _.cloneDeep(node);
    const { id } = node;
    newRootNode["uid"] = id;
    switch (id) {
      case "CURRICULUM_CONFIGURATIONS":
        {
          const {
            nodes: menuNodes,
            childrenNodes: childrenMenuNodes,
          } = getCurriculumProgramMenuNodes({
            dynamicNodes,
            curriculumPrograms,
          });
          newRootNode.children = _.map(menuNodes, "uid");

          newAdminMenuNodes.push(...menuNodes, ...childrenMenuNodes);
          newAdminMenuRootNodes.push(newRootNode);
        }
        break;
      case "SCHOOL_CONFIGURATIONS":
        {
          let menuNodes;
          if (ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION)) {
            menuNodes = getSchoolConfigurationsMenuNodesWrtRnP({
              staticNodes,
              curriculumPrograms,
              curriculumConfigMap,
            });
          } else {
            menuNodes = getSchoolConfigurationsMenuNodes({
              staticNodes,
              curriculumPrograms,
              curriculumConfigMap,
            });
          }

          newAdminMenuNodes.push(...menuNodes);
          newAdminMenuRootNodes.push(newRootNode);
        }
        break;
    }
  });

  const enhancedNewAdminMenuNodes = adminMenuNodeEnhancer({
    nodes: newAdminMenuNodes,
  });
  return {
    rootNodes: newAdminMenuRootNodes,
    nodes: enhancedNewAdminMenuNodes,
  };
};
